{
	"actions": {
		"title": "Actions",
		"save": "Save",
		"edit": "Edit",
		"delete": "Delete",
		"remove": "Remove",
		"deleting": "Deleting",
		"see": "View",
		"open": "Open",
		"back": "Back",
		"close": "Close",
		"cancel": "Cancel",
		"download": "Download"
	},
	"theme": {
		"light": "Light",
		"dark": "Dark",
		"toggle": "Toggle theme"
	},
	"language": "Language",
	"auth": {
		"pets": "Pets",
		"logoAriaLabel": "Pets logo",
		"links": {
			"forgotPassword": "Forgot password",
			"createAccount": "Create account",
			"backToLogin": "Back to login",
			"alreadyHaveAccount": "I already have an account"
		},
		"login": {
			"title": "Sign In",
			"submit": "Sign In",
			"loadingAria": "Signing in"
		},
		"forgotPassword": {
			"title": "Forgot password",
			"submit": "Send token",
			"loadingAria": "Sending token"
		},
		"resetPassword": {
			"title": "Reset password",
			"submit": "Save new password",
			"loadingAria": "Saving new password"
		},
		"signup": {
			"title": "Create account",
			"submit": "Create account",
			"loadingAria": "Creating account",
			"termsLabel": "I have read and accept the",
			"termsLinkLabel": "terms of use",
			"options": {
				"referralSource": {
					"indicacao": "Referral",
					"redesSociais": "Social media",
					"pesquisaGoogle": "Google search",
					"veterinario": "Veterinarian",
					"outro": "Other"
				}
			}
		},
		"verify": {
			"title": "Confirm email",
			"submit": "Confirm",
			"submitAria": "Confirm email",
			"loadingAria": "Confirming email",
			"resend": "Resend token",
			"resending": "Resending…",
			"resendIn": "Resend in { seconds }s"
		},
		"acceptInvite": {
			"title": {
				"loading": "Accept invite",
				"needPassword": "Finish setting up your access",
				"redirecting": "Redirecting…"
			},
			"info": {
				"needPassword": "Create a password to complete registration and access the pet.",
				"invitedEmail": "Invite email: <strong>{email}</strong>"
			},
			"loading": {
				"validating": "Validating invite…",
				"redirecting": "Redirecting…"
			},
			"submit": "Finish and access",
			"submitAria": "Finish registration and access",
			"retry": "Try again",
			"errors": {
				"missing_token": {
					"title": "Invalid link",
					"message": "The invite link is incomplete. Request a new invite to access the system."
				},
				"invalid_token": {
					"title": "Invalid invite",
					"message": "Request a new invite to access the system."
				},
				"invalid_invite": {
					"title": "Invalid invite",
					"message": "This invite data is incomplete. Ask the tutor for a new invite to access the system."
				},
				"invite_expired": {
					"title": "Invite expired",
					"message": "This invite has expired. Ask the tutor for a new invite to access the system."
				},
				"invite_revoked": {
					"title": "Invite cancelled",
					"message": "This invite was cancelled by the tutor. Request a new invite to access the system."
				},
				"invite_rejected": {
					"title": "Invite declined",
					"message": "This invite was declined. Ask the tutor for a new invite if you still want access."
				},
				"invite_used": {
					"title": "Invite already used",
					"message": "This invite was already accepted. Sign in to access the system."
				},
				"user_blocked": {
					"title": "Access blocked",
					"message": "Your account is not enabled for access. Contact the tutor or support."
				},
				"pet_not_found": {
					"title": "Pet unavailable",
					"message": "The pet for this invite is no longer available. Ask the tutor for a new invite."
				},
				"bad_request": {
					"title": "Could not process",
					"message": "Could not process the invite. Try opening the link again or request a new invite."
				},
				"db_error": {
					"title": "Save error",
					"message": "An error occurred while completing registration. Please try again in a moment."
				},
				"no_jwt": {
					"title": "Could not complete",
					"message": "Could not start your session. Try again or sign in."
				},
				"unauthorized": {
					"title": "Session expired",
					"message": "Your session has expired or is invalid. Try again or sign in."
				},
				"generic": {
					"title": "Error accepting invite",
					"message": "Could not complete the invite acceptance. Please try again in a moment."
				}
			}
		},
		"rejectInvite": {
			"title": {
				"loading": "Decline invite",
				"confirm": "Decline invite",
				"done": "Invite declined",
				"error": "Could not decline"
			},
			"info": {
				"confirm": "Are you sure you want to decline this invite to access a pet?",
				"fromTutor": "Sent by {name}"
			},
			"loading": {
				"validating": "Validating invite…"
			},
			"submit": "Decline invite",
			"submitting": "Declining…",
			"success": "Invite declined successfully. You will not receive further notifications about it.",
			"errors": {
				"missing_token": "The link is incomplete. Open the invite email again.",
				"invalid_token": "This invite is not valid or has already been processed.",
				"invalid_invite": "This invite data is incomplete.",
				"invite_expired": "This invite has expired.",
				"invite_revoked": "This invite was cancelled by the tutor.",
				"invite_rejected": "This invite was already declined.",
				"invite_used": "This invite was already accepted.",
				"generic": "Could not decline the invite. Please try again in a moment."
			}
		},
		"errors": {
			"invalidCredentials": "Invalid credentials",
			"emailNotVerified": "Confirm your email before signing in",
			"accountDeleted": "This account was removed. Contact support.",
			"accountBlocked": "This account is blocked. Contact support.",
			"loginFailed": "Sign in failed",
			"emailInUse": "This email is already in use",
			"passwordConfirmMismatch": "Passwords do not match",
			"signupFailed": "Failed to create account",
			"tokenExpired": "Token expired. Request another one.",
			"tokenInvalid": "Invalid token",
			"verifyTokenExpired": "Token expired. Request a new one.",
			"verifyTokenInvalid": "Invalid token",
			"verifyResendEmailInvalid": "Enter a valid email to resend",
			"verifyResendFailed": "Failed to resend token"
		},
		"messages": {
			"forgotPasswordInfo": "If an account exists for this email, we will send a token.",
			"resetPasswordSuccess": "Password updated. You can sign in now.",
			"verifySuccess": "Email confirmed. You can sign in now.",
			"verifyResendSuccess": "We sent a new token to your email."
		}
	},
	"emptyState": {
		"generic": {
			"default": {
				"title": "No results found",
				"description": "Try adjusting the filters or creating a new item.",
				"action": "Create item",
				"actionAriaLabel": "Create new item"
			},
			"search": {
				"title": "Nothing found",
				"description": "Try changing the filters or searching for another term."
			},
			"permission": {
				"title": "Action unavailable",
				"description": "You do not have permission to create this item yet."
			}
		},
		"pets": {
			"user": {
				"title": "It's great to have you here!",
				"description": "Register your first pet to start tracking their care.",
				"action": "+ Pet",
				"actionAriaLabel": "Register new pet"
			},
			"userFiltered": {
				"title": "No pets found",
				"description": "No pets match the current filters. Try clearing the search or changing species/sex."
			},
			"vet": {
				"title": "No shared pets yet",
				"description": "When an owner shares a pet with you, it will appear here."
			},
			"master": {
				"title": "No pets found",
				"description": "Try clearing the filters or selecting a specific tutor."
			},
			"masterMine": {
				"title": "You have no registered pets",
				"description": "Register a pet or switch scope to view pets from other tutors."
			},
			"masterMineFiltered": {
				"title": "No pets found",
				"description": "None of your pets match the current filters. Try clearing the search or changing species/sex."
			},
			"masterWithTutor": {
				"title": "No pets found for this tutor",
				"description": "Try clearing the filters or selecting another tutor."
			},
			"masterWithTutorFiltered": {
				"title": "No pets found for this tutor",
				"description": "No pets from this tutor match the current filters. Try clearing the search or changing species/sex."
			},
			"masterAll": {
				"title": "No pets found",
				"description": "No pets from other tutors match the current filters."
			},
			"masterAllFiltered": {
				"title": "No pets found",
				"description": "No pets from other tutors match the current filters."
			},
			"onlyWithAlerts": {
				"title": "No pets with alerts",
				"description": "No pets with active alerts were found for the selected filters."
			}
		}
	},
	"form-fields": {
		"email": "Email",
		"emailPlaceholder": "your@email.com",
		"password": "Password",
		"passwordPlaceholder": "Your password",
		"token": "Token",
		"tokenPlaceholder": "Paste the token you received",
		"newPassword": "New password",
		"newPasswordPlaceholder": "At least 8 characters",
		"passwordConfirm": "Confirm password",
		"passwordConfirmPlaceholder": "Repeat your password",
		"fullName": "Full name",
		"fullNamePlaceholder": "Your name",
		"preferredName": "Preferred name",
		"preferredNamePlaceholder": "How you want to be called",
		"referralSource": "How did you hear about us?",
		"referralSourcePlaceholder": "Select",
		"referralDetail": "Who referred you, or where did you find us?",
		"referralDetailPlaceholder": "E.g.: Instagram, friend, clinic…",
		"measuredAt": "Weigh-in date",
		"weightKg": "Weight (kg)",
		"weightKgPlaceholder": "E.g.: 2.50"
	},
	"validation": {
		"required": "*Required field",
		"requiredTerms": "*Accept the terms to continue",
		"min": "*Enter a value greater than or equal to the allowed minimum",
		"minlength": "*Minimum {requiredLength} characters",
		"invalidEmail": "*Invalid e-mail",
		"invalidValue": "*Invalid value",
		"invalidDate": "*Invalid date",
		"futureDate": "*Date cannot be in the future",
		"adoptionBeforeBirth": "*Adoption date cannot be before birth date",
		"passwordMismatch": "*Passwords do not match"
	},
	"form-filter": {
		"title": {
			"list": "Filter list",
			"filterOf": "Filter {tipo}"
		},
		"placeholders": {
			"name": "Search for name",
			"species": {
				"title": "Specie"
			},
			"sex": {
				"title": "Sex"
			},
			"tutor": {
				"selectTutor": "Select tutor",
				"scope": "Scope",
				"scopeMine": "My pets",
				"scopeAll": "All tutors",
				"search": "Search tutor",
				"choose": "Choose a tutor",
				"noneFound": "No tutor available",
				"lookingPetFrom": "Viewing pets of:",
				"noneSelectedMine": "Showing your pets.",
				"noneSelectedAll": "Showing pets from all tutors.",
				"totalPets": "Total number of pets:"
			}
		},
		"buttons": {
			"clear": "Clear",
			"clearSelection": "Clear selection",
			"refreshList": "Refresh list",
			"onylWithAlerts": "Only pets with alerts"
		},
		"total": "{total, plural, =0{<strong>no pets</strong>} =1{<strong>{total}</strong> pet} other{<strong>{total}</strong> pets}}"
	},
	"home": {
		"alerts": {
			"title": "Alerts",
			"refresh": "Refresh",
			"refreshing": "Refreshing...",
			"viewMore": "View more",
			"pageTitle": "Alerts",
			"pageSubtitle": "All alerts for your pets",
			"pageTitlePet": "Pet alerts",
			"pageSubtitlePet": "Alerts and pending items for this pet",
			"tabs": {
				"all": "All",
				"danger": "Urgent",
				"warn": "Soon",
				"info": "Informational"
			},
			"groups": {
				"danger": "Urgent",
				"warn": "Soon",
				"info": "Informational"
			},
			"empty": {
				"title": "Everything is up to date!",
				"description": "No alerts were found for the selected pets."
			},
			"preventives": {
				"vermifugo": "Dewormer",
				"antiPulgas": "Flea treatment"
			},
			"items": {
				"birthday": "Birthday",
				"birthdayWithYears": "Happy birthday! {years} years old",
				"vaccine": "Vaccine {type}",
				"vaccineAnnualSoon": "Annual vaccination is coming up",
				"vaccineAnnualOverdue": "Annual vaccination is overdue",
				"vaccineIndividualSoon": "{name} vaccine due soon",
				"vaccineIndividualOverdue": "{name} vaccine overdue",
				"vaccineMissing": "No vaccine registered",
				"glycemia": "Glucose measurement",
				"treatment": "{name}",
				"preventive": "{kind}",
				"preventiveFallback": "Preventive",
				"visit": "Visit",
				"weightNever": "Never weighed",
				"weightStale": "No weighing in over 6 months"
			},
			"time": {
				"today": "today",
				"inDays": "in {days} days",
				"inDaysWithDate": "in {days} days · {date}",
				"overdue": "{days} days overdue",
				"overdueWithDate": "{days} days overdue · due {date}",
				"dueToday": "today · {date}",
				"pending": "Pending",
				"lastWeighing": "last: {date}",
				"withClock": "{label} · {time}"
			}
		}
	},
	"list": {
		"errors": {
			"loadPets": "Could not load pets.",
			"loadAlerts": "Could not load alerts.",
			"loadTutors": "Could not load tutors.",
			"deletePet": "Could not delete the pet.",
			"leaveSharedPet": "Could not remove the pet from your list.",
			"loadMorePets": "Could not load more pets."
		},
		"loadError": {
			"title": "Could not load pets",
			"description": "Check your connection and try again.",
			"retry": "Try again"
		},
		"loadingMorePets": "Loading more pets...",
		"loadingPetsAria": "Loading pets",
		"petCard": {
			"tutor": "Owner",
			"deleteAria": "Delete pet",
			"leaveAria": "Remove pet from list",
			"fallbackName": "Pet"
		},
		"deletePet": {
			"title": "Delete pet?",
			"contentWithName": "Are you sure you want to delete \"{name}\"?",
			"contentGeneric": "Are you sure you want to delete this pet?",
			"confirm": "Delete",
			"cancel": "Cancel"
		},
		"leaveSharedPet": {
			"title": "Remove pet from your list?",
			"contentWithName": "Are you sure you want to remove \"{name}\" from your list? You will lose access to this pet.",
			"contentGeneric": "Are you sure you want to remove this pet from your list?",
			"confirm": "Remove",
			"cancel": "Cancel",
			"success": "Pet removed from your list."
		},
		"vetInvites": {
			"title": "Pets to approve",
			"count": "{count, plural, =0{no invites} =1{1 invite} other{{count} invites}}",
			"refresh": "Refresh",
			"close": "Close",
			"ok": "Ok",
			"approve": "Approve",
			"reject": "Reject",
			"columns": {
				"pet": "Pet",
				"tutor": "Owner",
				"status": "Status",
				"actions": "Actions"
			},
			"emptyTitle": "No invites found",
			"emptyDescription": "When an owner shares a pet with you, it will appear here.",
			"emailMissing": "Could not identify the user email from the token.",
			"loadFailed": "Could not load invites.",
			"approveSuccess": "Access approved.",
			"approveFailed": "Could not approve access.",
			"rejectTitle": "Reject invite?",
			"rejectContent": "You will not have access to \"{petName}\". Owner: {tutor}.",
			"rejectSuccess": "Invite rejected.",
			"rejectFailed": "Could not reject the invite.",
			"status": {
				"pending": "Pending",
				"expired": "Expired",
				"accepted": "Accepted",
				"revoked": "Revoked",
				"unknown": "—"
			}
		},
		"vaccines": {
			"loading": "Loading vaccines",
			"close": "Close",
			"ok": "Ok",
			"fallbackName": "Vaccine",
			"filters": {
				"searchLabel": "Vaccine",
				"searchPlaceholder": "Filter by vaccine or brand",
				"typeLabel": "Type",
				"typePlaceholder": "Vaccine type",
				"typeClearAria": "Clear vaccine type",
				"typeSearchPlaceholder": "Search vaccine type",
				"typeSearchAria": "Search vaccine type",
				"typeEmpty": "No types found",
				"productLabel": "Product",
				"productPlaceholder": "Product / commercial brand",
				"productClearAria": "Clear product",
				"productSearchPlaceholder": "Search product",
				"productSearchAria": "Search product",
				"productEmpty": "No products found"
			},
			"columns": {
				"vaccine": "Vaccine",
				"brand": "Brand",
				"dose": "Dose",
				"administeredAt": "Administered on",
				"nextDoseAt": "Next dose",
				"professional": "Veterinarian",
				"clinic": "Clinic",
				"context": "Context",
				"location": "Location",
				"notes": "Notes",
				"actions": "Actions"
			},
			"unknown": "Not informed",
			"empty": {
				"title": "No vaccines recorded",
				"description": "How about scheduling the next one? Keep your pet protected!"
			},
			"noResults": {
				"title": "No vaccines found",
				"description": "Try adjusting the filters to find what you are looking for."
			},
			"actions": {
				"editAria": "Edit vaccine",
				"deleteAria": "Delete vaccine"
			},
			"delete": {
				"title": "Delete vaccine application?",
				"contentWithName": "Are you sure you want to delete \"{name}\"?",
				"contentGeneric": "Are you sure you want to delete this vaccine application?",
				"confirm": "Delete",
				"cancel": "Cancel",
				"success": "Vaccine deleted successfully."
			},
			"errors": {
				"load": "Could not load vaccines.",
				"loadTypes": "Could not load vaccine types.",
				"loadProducts": "Could not load vaccine products.",
				"delete": "Could not delete the vaccine."
			}
		},
		"preventives": {
			"loading": "Loading preventives",
			"protectionDays": "{days} days",
			"protectionMonths": "{months} months",
			"filters": {
				"searchLabel": "Preventive",
				"searchPlaceholder": "Filter by product or type (collar, pipette...)",
				"kindLabel": "Type",
				"kindPlaceholder": "Which",
				"kindClearAria": "Clear type"
			},
			"columns": {
				"kind": "Type",
				"method": "Method",
				"product": "Product",
				"appliedAt": "Applied on",
				"nextDueAt": "Next dose",
				"protection": "Protection",
				"notes": "Notes",
				"actions": "Actions"
			},
			"empty": {
				"title": "No preventives registered",
				"description": "Add flea & tick and dewormer treatments to track doses!"
			},
			"noResults": {
				"title": "No preventives found",
				"description": "Try adjusting the filters to find what you are looking for."
			},
			"actions": {
				"editAria": "Edit preventive",
				"deleteAria": "Delete preventive"
			},
			"delete": {
				"title": "Delete preventive?",
				"contentWithName": "Are you sure you want to delete \"{name}\"?",
				"contentGeneric": "Are you sure you want to delete this preventive?",
				"confirm": "Delete",
				"cancel": "Cancel",
				"success": "Preventive deleted successfully."
			},
			"errors": {
				"load": "Could not load preventives.",
				"delete": "Could not delete the preventive."
			}
		},
		"treatments": {
			"loading": "Loading treatments",
			"close": "Close",
			"ok": "Ok",
			"filters": {
				"searchLabel": "Filter",
				"searchPlaceholder": "Filter by medication, reason or veterinarian",
				"statusLabel": "Status",
				"statusPlaceholder": "Status",
				"statusClearAria": "Clear status"
			},
			"status": {
				"draft": "Draft",
				"active": "Active",
				"paused": "Paused",
				"finished": "Finished",
				"cancelled": "Cancelled"
			},
			"schedule": {
				"daily": "Daily",
				"dailyTimes": "{count}x per day",
				"weekly": "Weekly",
				"monthly": "Monthly"
			},
			"form": {
				"tabsAria": "Treatment",
				"planSection": "Plan details",
				"itemsSection": "Plan items",
				"itemsTabAria": "Treatment items",
				"itemLabel": "Item {number}",
				"tabs": {
					"general": "General",
					"frequency": "Frequency and times",
					"dose": "Dose",
					"package": "Package and stock",
					"notes": "Notes",
					"plan": "Plan",
					"items": "Items",
					"validity": "Validity"
				},
				"fields": {
					"planName": "Plan name",
					"generalInstructions": "General instructions",
					"itemName": "Item name",
					"details": "Details",
					"medName": "Medication",
					"medPresentation": "Presentation",
					"medManufacturer": "Manufacturer",
					"conditions": "Clinical conditions",
					"startedAt": "Start",
					"durationMode": "Duration",
					"durationDays": "In days",
					"untilDate": "End date",
					"vetName": "Veterinarian",
					"reason": "Reason",
					"frequencyMode": "Frequency",
					"times": "Times",
					"time": "Time",
					"weeklyWeekdays": "Days of the week",
					"monthlyMonthdays": "Days of the month",
					"doseValue": "Dose",
					"doseUnit": "Unit",
					"doseRoute": "Route",
					"insulinKind": "Insulin type",
					"insulinConcentration": "Concentration",
					"insulinDelivery": "Presentation",
					"openedAt": "Opened on",
					"openedValidDays": "Lasts after opening (days)",
					"discardAt": "Discard on",
					"expiresAt": "Expiration",
					"amountTotal": "Total amount",
					"amountUnit": "Unit",
					"amountRemaining": "Remaining",
					"lowStockThreshold": "Low stock alert",
					"noteText": "Add note",
					"estimatedEndDate": "Estimated end",
					"visit": "Visit",
					"veterinarian": "Veterinarian",
					"vetOther": "Other",
					"vetCrmv": "License (CRMV)",
					"hasPause": "Treatment interval",
					"pauseDays": "Pause days",
					"durationAgain": "Duration again (days)",
					"isInsulin": "Insulin"
				},
				"placeholders": {
					"conditions": "Select one or more conditions",
					"select": "Select",
					"doseUnit": "e.g.: IU, mg, ml",
					"doseRoute": "e.g.: oral, SC",
					"amountUnit": "e.g.: ml, tablets",
					"visit": "Link to a visit"
				},
				"linkedPreventivesTitle": "Linked preventives",
				"hints": {
					"noConditions": "No conditions registered yet.",
					"noteSaveWithTreatment": "This note will be saved with the treatment when you click “Save”.",
					"visitLocked": "Visit comes from the prescription and cannot be changed."
				},
				"actions": {
					"addItem": "Add item",
					"removeItem": "Remove item",
					"removeTime": "Remove",
					"addTime": "Add time",
					"saveNote": "Save note",
					"registerPreventive": "Register as preventive"
				},
				"duration": {
					"indefinite": "Indefinite",
					"continuous": "Continuous",
					"for_days": "For days",
					"until_date": "Until a date"
				},
				"frequency": {
					"daily": "Daily",
					"weekly": "Weekly",
					"monthly": "Monthly"
				},
				"weekdays": {
					"0": "Sun",
					"1": "Mon",
					"2": "Tue",
					"3": "Wed",
					"4": "Thu",
					"5": "Fri",
					"6": "Sat"
				},
				"insulin": {
					"kind": {
						"glargine": "Glargine",
						"pzi": "PZI / ProZinc",
						"lente": "Lente (Vetsulin)",
						"nph": "NPH",
						"detemir": "Detemir",
						"other": "Other"
					},
					"concentration": {
						"U40": "U-40",
						"U100": "U-100",
						"other": "Other"
					},
					"delivery": {
						"vial": "Vial",
						"pen": "Pen",
						"cartridge": "Cartridge"
					}
				},
				"errors": {
					"scheduleRequired": "Fill in the frequency and at least one time.",
					"durationDaysRequired": "Enter the number of days.",
					"untilDateRequired": "Enter the end date.",
					"vetRequired": "Enter the veterinarian name and license."
				},
				"successSave": "Treatment saved successfully.",
				"successEdit": "Treatment updated successfully.",
				"errorSave": "Could not save the treatment.",
				"outerTabsAria": "Treatment plan sections"
			},
			"validity": {
				"opened": "Opened",
				"discard": "Discard"
			},
			"columns": {
				"startedAt": "Start",
				"medication": "Plan / treatment",
				"items": "Items",
				"vet": "Veterinarian",
				"dose": "Dose",
				"schedule": "Frequency",
				"validity": "Validity after opening",
				"status": "Status",
				"actions": "Actions"
			},
			"empty": {
				"title": "No treatments registered",
				"description": "Add a treatment and track doses and expiration."
			},
			"noResults": {
				"title": "No treatments found",
				"description": "Try adjusting the filters to find what you are looking for."
			},
			"actions": {
				"editAria": "Edit treatment",
				"pauseAria": "Pause treatment",
				"reactivateAria": "Reactivate treatment",
				"finishAria": "Finish treatment",
				"deleteAria": "Delete treatment",
				"viewAria": "View treatment"
			},
			"pause": {
				"success": "Treatment paused."
			},
			"reactivate": {
				"success": "Treatment reactivated."
			},
			"finish": {
				"title": "Finish treatment?",
				"contentWithName": "Are you sure you want to finish \"{name}\"?",
				"contentGeneric": "Are you sure you want to finish this treatment?",
				"confirm": "Finish",
				"cancel": "Cancel",
				"success": "Treatment finished."
			},
			"delete": {
				"title": "Delete treatment?",
				"contentWithName": "Are you sure you want to delete \"{name}\"? This action cannot be undone.",
				"contentGeneric": "Are you sure you want to delete this treatment? This action cannot be undone.",
				"confirm": "Delete",
				"cancel": "Cancel",
				"success": "Treatment deleted."
			},
			"errors": {
				"load": "Could not load treatments.",
				"status": "Could not update treatment status.",
				"delete": "Could not delete the treatment."
			}
		},
		"consultations": {
			"loading": "Loading consultations",
			"close": "Close",
			"ok": "Ok",
			"filters": {
				"visitedFromLabel": "Visit date (from)",
				"visitedToLabel": "Visit date (to)",
				"nextVisitFromLabel": "Follow-up date (from)",
				"nextVisitToLabel": "Follow-up date (to)",
				"kindLabel": "Visit type",
				"kindPlaceholder": "Type",
				"kindClearAria": "Clear visit type",
				"modeLabel": "Visit mode",
				"modePlaceholder": "Mode",
				"modeClearAria": "Clear visit mode",
				"vetLabel": "Veterinarian",
				"vetPlaceholder": "Name or CRMV",
				"clinicLabel": "Clinic",
				"clinicPlaceholder": "Filter by clinic"
			},
			"kinds": {
				"routine": "Routine",
				"follow_up": "Follow-up",
				"return": "Follow-up",
				"urgent": "Urgent",
				"emergency": "Emergency",
				"monitoring": "Monitoring",
				"preoperative": "Preoperative",
				"postoperative": "Postoperative",
				"vaccination": "Vaccination",
				"exam": "Exam evaluation",
				"other": "Other"
			},
			"modes": {
				"clinic": "Clinic",
				"home": "Home visit",
				"telehealth": "Telehealth",
				"campaign": "Campaign",
				"shelter": "Shelter",
				"other": "Other"
			},
			"pain": {
				"yes": "Yes",
				"no": "No",
				"unknown": "Unknown"
			},
			"diagnosisStatus": {
				"suspected": "Suspected",
				"under_investigation": "Under investigation",
				"probable": "Probable",
				"confirmed": "Confirmed",
				"ruled_out": "Ruled out",
				"known_condition": "Known condition",
				"other": "Other"
			},
			"prescriptionTypes": {
				"medication": "Medication",
				"fluid_therapy": "Fluid therapy",
				"physiotherapy": "Physiotherapy",
				"supplement": "Supplement",
				"diet": "Diet",
				"home_care": "Home care",
				"monitoring": "Monitoring",
				"restriction": "Restriction",
				"follow_up": "Follow-up",
				"other": "Other"
			},
			"prescriptionSources": {
				"written": "Written prescription",
				"verbal": "Verbal guidance",
				"attachment": "Attachment",
				"clinic_report": "Clinic report",
				"tutor_notes": "Tutor notes",
				"other": "Other"
			},
			"reportedSigns": {
				"apathy": "Apathy",
				"perceived_fever": "Perceived fever",
				"vomiting": "Vomiting",
				"diarrhea": "Diarrhea",
				"itching": "Itching",
				"loss_of_appetite": "Loss of appetite",
				"increased_appetite": "Increased appetite",
				"increased_thirst": "Increased thirst",
				"increased_urination": "Increased urination",
				"difficulty_urinating": "Difficulty urinating",
				"cough": "Cough",
				"difficulty_breathing": "Difficulty breathing",
				"difficulty_walking": "Difficulty walking",
				"discharge": "Discharge",
				"bleeding": "Bleeding",
				"behavior_change": "Behavior change",
				"pain": "Pain",
				"other": "Other"
			},
			"columns": {
				"visitedAt": "Visit date",
				"nextVisitAt": "Follow-up date",
				"kind": "Type",
				"mode": "Mode",
				"vet": "Veterinarian",
				"clinic": "Clinic",
				"links": "Links",
				"notes": "Notes",
				"actions": "Actions"
			},
			"links": {
				"separator": " · ",
				"vaccine": "{count} vaccine",
				"vaccines": "{count} vaccines",
				"exam": "{count} exam",
				"exams": "{count} exams",
				"condition": "{count} condition",
				"conditions": "{count} conditions"
			},
			"empty": {
				"title": "No consultations registered",
				"description": "How about scheduling a check-up for your pet?"
			},
			"noResults": {
				"title": "No consultations found",
				"description": "Try adjusting the filters to find what you are looking for."
			},
			"actions": {
				"editAria": "Edit consultation",
				"deleteAria": "Delete consultation"
			},
			"delete": {
				"title": "Delete consultation?",
				"contentGeneric": "This action cannot be undone.",
				"confirm": "Delete",
				"cancel": "Cancel",
				"success": "Consultation deleted."
			},
			"errors": {
				"load": "Could not load consultations.",
				"delete": "Could not delete the consultation."
			},
			"form": {
				"tabsAria": "Consultation form tabs",
				"tabs": {
					"general": "General information",
					"history": "History and physical exam",
					"vaccines": "Vaccine",
					"exams": "Exams",
					"diagnosis": "Hypotheses and diagnoses",
					"conduct": "Actions performed",
					"prescription": "Prescription and guidance",
					"documents": "Documents",
					"finance": "Financial"
				},
				"visitedAtDate": "Visit date",
				"visitedAtTime": "Time",
				"visitType": "Type",
				"visitMode": "Mode",
				"clinic": "Clinic",
				"clinicPlaceholder": "Search clinic or location",
				"clinicOther": "Other",
				"clinicName": "Clinic / location name",
				"clinicNamePlaceholder": "E.g. Clinic X",
				"veterinarian": "Veterinarian",
				"vetPlaceholder": "Search by name or CRMV",
				"vetOther": "Other",
				"vetName": "Veterinarian name",
				"vetNamePlaceholder": "Full name",
				"vetCrmv": "CRMV",
				"vetCrmvPlaceholder": "E.g. CRMV-SP 12345",
				"nextVisitAt": "Follow-up date",
				"returnReason": "Follow-up goal",
				"reason": "Reason for visit",
				"reasonPlaceholder": "E.g. vomiting, check-up, follow-up",
				"notes": "Visit notes",
				"weightKg": "Weight (kg)",
				"tempC": "Temperature (°C)",
				"tempLo": "LOW/LO (no temperature)",
				"tempLoTooltip": "Check when the thermometer could not measure temperature (below scale or invalid reading). Temperature will not be recorded.",
				"relatedVisit": "Source visit",
				"relatedVisitPlaceholder": "Select the previous visit",
				"heartRateBpm": "Heart rate (bpm)",
				"respRateBpm": "Respiratory rate",
				"capillaryRefillSec": "Capillary refill (s)",
				"systolicBloodPressure": "Systolic blood pressure (mmHg)",
				"mucousMembrane": "Mucous membranes",
				"hydrationStatus": "Hydration",
				"bodyConditionScore": "Body condition score",
				"bodyConditionScale": "Body condition scale",
				"historyText": "History reported by the tutor",
				"reportedSigns": "Signs perceived by the tutor",
				"painReported": "Did the tutor perceive pain?",
				"painDetails": "Reported pain details",
				"examSummary": "Exam summary",
				"findings": "Physical exam findings",
				"generalConduct": "General actions performed during the visit",
				"examRequests": "Requested exams",
				"examRequestsPlaceholder": "Select panels and exams",
				"examPanelPrefix": "Panel:",
				"otherExamTitle": "Other exam (outside catalog)",
				"otherExamHint": "Use when the requested exam is not in the catalog.",
				"otherExamName": "Exam name",
				"otherExamNamePlaceholder": "E.g. Full liver panel",
				"otherExamNameRequired": "Enter the exam name to add it.",
				"otherExamKind": "Kind (optional)",
				"otherExamKindNone": "Not specified",
				"otherExamKindPlaceholder": "Select kind",
				"otherExamNotes": "Notes (optional)",
				"otherExamNotesPlaceholder": "Request details",
				"otherExamAdd": "Add other exam",
				"freeExamTitle": "Free title / document request",
				"freeExamTitlePlaceholder": "E.g. Clinic X exam request",
				"documentOnlyRequest": "Document-only request (no structured items)",
				"diagnosis": "Diagnosis",
				"conditionOr": "OR",
				"conditionLink": "Link existing condition",
				"conditionLinkPlaceholder": "Search pet conditions",
				"conditionDiagnosisNote": "Diagnosis (note)",
				"conditionDiagnosisNotePlaceholder": "Describe the clinical diagnosis",
				"conditionNameRequired": "Enter a condition name or link an existing one to save the clinical condition details.",
				"diagnosisName": "Hypothesis or diagnosis",
				"diagnosisStatus": "Status",
				"diagnosisNotes": "Notes",
				"newConditionName": "Create condition named",
				"addDiagnosis": "Add hypothesis or diagnosis",
				"proceduresDone": "Procedures performed",
				"medsAdministered": "Medications administered",
				"prescriptionOriginal": "Original prescription text",
				"prescriptionSource": "Prescription source",
				"prescriptionGeneralInstructions": "General instructions",
				"prescriptionItemType": "Instruction type",
				"prescriptionItemName": "Name",
				"doseText": "Dose",
				"frequencyText": "Frequency",
				"durationText": "Duration",
				"route": "Route",
				"prescriptionItemInstructions": "Instructions",
				"addPrescriptionItem": "Add prescription item",
				"createTreatmentFromPrescription": "Create treatment from prescription",
				"treatmentFromPrescriptionSuccess": "Treatment plan created from the prescription.",
				"treatmentFromPrescriptionError": "Could not create a treatment from the prescription.",
				"prescriptionUpload": "Prescription attachments",
				"diagnosisUpload": "Reports and documents for this diagnosis",
				"examUpload": "Exam request attachments",
				"financeUpload": "Receipts and invoices",
				"uploadDropzone": "Drag files here or select them from your device",
				"uploadBrowse": "Select files",
				"uploadConstraints": "PDF, JPG, PNG or WEBP up to 10 MB per file",
				"uploadAddMore": "Add more files",
				"uploadInvalidType": "This file type is not allowed.",
				"uploadTooLarge": "The file exceeds the __MAX_SIZE__ limit.",
				"uploadDocument": "Upload document (PDF or image)",
				"documentsEmpty": "No documents attached to this visit.",
				"documentUploadSuccess": "Document uploaded.",
				"documentUploadError": "Could not upload the document.",
				"documentDeleteError": "Could not delete the document.",
				"documentOpenError": "Could not open the document.",
				"costTotal": "Total cost",
				"paidTotal": "Amount paid",
				"paymentMethod": "Payment method",
				"successSave": "Consultation saved successfully.",
				"successEdit": "Consultation updated successfully.",
				"errorSave": "Could not save the consultation.",
				"weightReplaceTitle": "Different weight already registered on this day",
				"weightReplaceDescription": "There is already a weight of {existing} kg on this day, and the visit has {next} kg. What would you like to do?",
				"weightReplaceConfirm": "Use the visit weight",
				"weightReplaceSkip": "Keep the existing weight",
				"documentViewImage": "View image",
				"documentOpenFile": "Open file",
				"documentDeleteSuccess": "Document removed.",
				"documentZoomIn": "Zoom in",
				"documentZoomOut": "Zoom out",
				"documentZoomReset": "{zoom}%",
				"financeDocumentDescription": "Financial receipt",
				"weightDuplicateDay": "A weight is already registered on this day",
				"documentsPrescriptionLabel": "Prescriptions",
				"documentsFinanceLabel": "Financial receipts",
				"documentsExamLabel": "Exam attachments",
				"documentsDiagnosisLabel": "Diagnosis documents",
				"documentDownloadError": "Could not download the document."
			}
		},
		"glycemia": {
			"loading": "Loading glucose curves",
			"tabsAria": "Glucose tabs",
			"tabs": {
				"daily": "Daily",
				"curve": "Curve",
				"compare": "Compare"
			},
			"close": "Close",
			"ok": "Ok",
			"columns": {
				"date": "Date",
				"startTime": "Start",
				"clicks": "Dose (IU)",
				"dose": "Dose (IU)",
				"pointsRecorded": "Points",
				"notes": "Notes",
				"actions": "Actions"
			},
			"pointsRecordedValue": "{count}/5",
			"doseUnit": "IU",
			"now": "now",
			"pointGlucosePlaceholder": "e.g. 122 or HI",
			"form": {
				"date": "Date",
				"startTime": "Start time",
				"warnMinutes": "Alert (min before)",
				"warnMinutesTooltip": "This delay is only for Web Push notifications. Overview alerts use a fixed 1-hour \"Soon\" window before the measurement time.",
				"warnMinutesReadonly": "Web Push alert (min before)",
				"doseUi": "Insulin dose (IU)",
				"autoScheduleHint": "Automatic points every 3h: {t1}, {t2}, {t3}, {t4}, {t5}",
				"sessionCreateSuccess": "Glycemic curve saved successfully.",
				"sessionErrorSave": "Could not save the glycemic curve."
			},
			"empty": {
				"title": "No glucose curve recorded",
				"description": "Record a curve to track dose response."
			},
			"actions": {
				"openAria": "Open measurement",
				"deleteAria": "Delete measurement"
			},
			"delete": {
				"title": "Delete measurement?",
				"contentWithDate": "Permanently delete the measurement from {date} with all individual values?",
				"contentGeneric": "Permanently delete this measurement with all individual values?",
				"confirm": "Delete",
				"cancel": "Cancel",
				"success": "Measurement deleted successfully."
			},
			"errors": {
				"load": "Could not load glucose curves.",
				"delete": "Could not delete the measurement.",
				"pointGlucoseAndTimeRequired": "Enter glucose and time to save the point.",
				"pointSave": "Could not save the curve point.",
				"glucoseConflictTitle": "Different glucose at the same time",
				"glucoseConflictDescription": "There is already a daily reading of {existing} at this time. The curve has {next}. What would you like to do?",
				"glucoseConflictConfirm": "Use the curve value",
				"glucoseConflictKeep": "Keep the daily value"
			},
			"daily": {
				"loading": "Loading daily glucose",
				"type": "Reading",
				"newTitle": "New daily reading",
				"newSubtitle": "Log glucose before insulin",
				"editTitle": "Edit daily reading",
				"editSubtitle": "Update glucose, time and insulin",
				"dateLockedHint": "The date cannot be changed. Adjust only time, glucose and insulin.",
				"createSuccess": "Reading saved successfully.",
				"updateSuccess": "Reading updated successfully.",
				"chartName": "Glucose",
				"chartRange": {
					"label": "Chart period",
					"d7": "7 days",
					"d15": "15 days",
					"d30": "30 days",
					"custom": "Custom",
					"from": "From",
					"to": "To",
					"apply": "Apply",
					"panelTitle": "Period chart",
					"min": "Lowest value: {value} mg/dL",
					"max": "Highest value: {value} mg/dL",
					"minPrefix": "Lowest value",
					"maxPrefix": "Highest value",
					"lowestPeriod": "Lowest period: {period}",
					"highestPeriod": "Highest period: {period}",
					"lowestPeriodPrefix": "Lowest period",
					"highestPeriodPrefix": "Highest period",
					"periodDawn": "Dawn (00h–06h)",
					"periodMorning": "Morning (06h–12h)",
					"periodAfternoon": "Afternoon (12h–18h)",
					"periodNight": "Night (18h–00h)",
					"periodUnknown": "Not enough data",
					"measurementsCountLabel": "Measurements in period",
					"measurementsCount": "Measurements in period: {count}",
					"insulinAppliedLabel": "Insulin doses applied",
					"rangeTooLong": "The custom period can be at most 6 months. Please choose a shorter range.",
					"loLegend": "LO (< 20/10 mg/dL)",
					"hiLegend": "HI (> 500/600 mg/dL)",
					"loCountLabel": "LO measurements",
					"hiCountLabel": "HI measurements",
					"flagsNote": "Also in period: {flags}",
					"generatePdf": "Generate PDF",
					"pdfTitle": "Daily glycemia",
					"pdfPeriod": "Period: {from} to {to}",
					"pdfFileName": "daily-glycemia-{from}_{to}.pdf",
					"pdfError": "Could not generate the PDF.",
					"pdfColumns": {
						"date": "Date",
						"time": "Time",
						"glucose": "mg/dL",
						"insulin": "Insulin dose",
						"notes": "Notes"
					}
				},
				"hiLabel": "HI (above meter limit)",
				"loLabel": "LO (below meter limit)",
				"glucoseMode": {
					"value": "Value",
					"lo": "LO",
					"hi": "HI"
				},
				"columns": {
					"time": "Time",
					"glucose": "mg/dL",
					"insulin": "Insulin"
				},
				"insulin": {
					"yes": "Administered",
					"no": "Not administered",
					"notRegistered": "Not recorded",
					"notAdministered": "I did not give insulin",
					"notAdministeredHint": "Check if you chose not to give insulin. Leaving the dose blank without checking means the dose was not recorded."
				},
				"empty": {
					"title": "No daily readings",
					"description": "Log day-to-day glucose to track control."
				},
				"actions": {
					"deleteAria": "Delete reading",
					"editAria": "Edit reading",
					"deleteLockedTooltip": "Curve-generated readings can only be deleted by an admin"
				},
				"delete": {
					"title": "Delete reading?",
					"content": "Permanently delete this daily reading?",
					"success": "Reading deleted successfully."
				},
				"errors": {
					"load": "Could not load daily glucose.",
					"loadOne": "Could not load the reading.",
					"save": "Could not save the reading.",
					"delete": "Could not delete the reading.",
					"glucoseRequired": "Enter a glucose value or mark LO or HI.",
					"duplicateDateTime": "A reading already exists at this date and time.",
					"duplicateSameValue": "A reading with the same value already exists at this date and time.",
					"glucoseConflictTitle": "Different glucose at the same time",
					"glucoseConflictDescription": "There is already a reading of {existing} at this time. The new value is {next}. What would you like to do?",
					"glucoseConflictConfirm": "Use the new value",
					"glucoseConflictKeep": "Keep the existing value"
				}
			},
			"compare": {
				"insufficientTitle": "Not enough measurements",
				"insufficientDescription": "You need at least 2 glucose curves to compare.",
				"measurementA": "Measurement A",
				"measurementB": "Measurement B",
				"measurementC": "Measurement C",
				"select": "Select",
				"selectOptional": "Select",
				"threshold": "Difference threshold",
				"run": "Compare",
				"note": "Note",
				"formPanelTitle": "Select measurements",
				"seriesNamed": "{label} ({date})",
				"hiDisplay": "HI (600+)",
				"notes": {
					"lower": "lower",
					"higher": "higher",
					"equal": "equal",
					"atLeast": "At least {delta}"
				}
			}
		},
		"conditions": {
			"loading": "Loading clinical conditions",
			"close": "Close",
			"ok": "Ok",
			"columns": {
				"name": "Name",
				"curability": "Curability",
				"status": "Status",
				"severity": "Severity",
				"diagnosedAt": "Diagnosed on",
				"actions": "Actions"
			},
			"curability": {
				"CURÁVEL": "Curable",
				"NÃO_CURÁVEL": "Not curable",
				"INDEFINIDO": "Under evaluation"
			},
			"status": {
				"ATIVA": "Active",
				"RESOLVIDA": "Resolved",
				"EM_MANEJO": "Under management",
				"DESCARTADA": "Dismissed"
			},
			"severity": {
				"BAIXA": "Low",
				"MODERADA": "Moderate",
				"ALTA": "High"
			},
			"conditionType": {
				"AGUDA": "Acute",
				"CRÔNICA": "Chronic",
				"CONGÊNITA": "Congenital",
				"RECORRENTE": "Recurrent",
				"DESCONHECIDA": "Unknown"
			},
			"bodySystem": {
				"ENDÓCRINO": "Endocrine",
				"RENAL": "Renal",
				"CARDÍACO": "Cardiac",
				"RESPIRATÓRIO": "Respiratory",
				"GASTROINTESTINAL": "Gastrointestinal",
				"NEUROLÓGICO": "Neurological",
				"OSTEOARTICULAR": "Musculoskeletal",
				"DERMATOLÓGICO": "Dermatological",
				"HEMATOLÓGICO": "Hematological",
				"OFTÁLMICO": "Ophthalmic",
				"OUTRO": "Other"
			},
			"controlStatus": {
				"BEM_CONTROLADA": "Well controlled",
				"PARCIALMENTE_CONTROLADA": "Partially controlled",
				"DESCOMPENSADA": "Decompensated"
			},
			"lifeRisk": {
				"BAIXO": "Low",
				"MODERADO": "Moderate",
				"ALTO": "High",
				"EMERGENCIAL": "Emergency"
			},
			"form": {
				"name": "Condition name",
				"curability": "Curability",
				"status": "Status",
				"severity": "Severity",
				"conditionType": "Condition type",
				"bodySystem": "Main body system / organ",
				"controlStatus": "Control status",
				"lifeRisk": "Associated life risk",
				"symptomStartAt": "Symptom onset",
				"diagnosedAt": "Diagnosed on",
				"resolvedAt": "Resolved on",
				"notes": "Initial note",
				"followupPlan": "Follow-up plan",
				"successSave": "Condition saved successfully.",
				"successEdit": "Condition updated successfully.",
				"errorSave": "Could not save the condition."
			},
			"details": {
				"tabs": {
					"aria": "Clinical condition tabs",
					"general": "General information",
					"notes": "Notes",
					"links": "Links"
				},
				"infoTitle": "Information",
				"notesTitle": "Notes",
				"linksTitle": "Links",
				"noteFormTitle": "Add note",
				"noteFormEditTitle": "Edit note",
				"noteContent": "Note",
				"notePlaceholder": "Write a note",
				"recordedAt": "Recorded on",
				"addNote": "Add note",
				"sortLabel": "Sort",
				"sortDesc": "Newest first",
				"sortAsc": "Oldest first",
				"notesEmpty": "No notes",
				"notesEmptyTitle": "No notes",
				"notesEmptyDescription": "Add the first note to track this condition's progress.",
				"columns": {
					"recordedAt": "Date",
					"content": "Note",
					"status": "Status",
					"severity": "Severity",
					"actions": "Actions"
				},
				"labResults": "Exam results",
				"labResultPlaceholder": "Select result",
				"treatments": "Treatments",
				"treatmentPlaceholder": "Select treatment",
				"link": "Link",
				"deleteNoteTitle": "Delete note?",
				"deleteNoteWithPreview": "This action cannot be undone. Note: \"{preview}\"",
				"deleteNoteGeneric": "This action cannot be undone.",
				"historyNotePrefix": "Clinical update: {changes}",
				"historyChange": "{field}: {from} → {to}",
				"historyEmpty": "not set",
				"saveSuccess": "Condition updated successfully.",
				"saveError": "Could not update the condition."
			},
			"empty": {
				"title": "No conditions found",
				"description": "This is the ideal place to track your pet's needs!"
			},
			"actions": {
				"openAria": "Open condition",
				"deleteAria": "Delete condition"
			},
			"delete": {
				"title": "Delete clinical condition?",
				"contentWithName": "This action cannot be undone. Condition: \"{name}\"",
				"contentGeneric": "This action cannot be undone.",
				"confirm": "Delete",
				"cancel": "Cancel",
				"success": "Condition deleted successfully."
			},
			"errors": {
				"load": "Could not load clinical conditions.",
				"delete": "Could not delete the condition."
			}
		},
		"exams": {
			"loading": "Loading exams",
			"close": "Close",
			"columns": {
				"requestedAt": "Requested on",
				"tests": "Requested tests",
				"clinic": "Clinic",
				"vet": "Veterinarian",
				"status": "Status",
				"progress": "Progress",
				"actions": "Actions"
			},
			"status": {
				"MISSING": "Pending",
				"PENDING": "Pending",
				"PARTIAL": "Partial",
				"DONE": "Completed",
				"DOCUMENT": "File only"
			},
			"empty": {
				"title": "No exams found",
				"description": "How about getting your pet's exams up to date?"
			},
			"actions": {
				"openAria": "Open exam",
				"deleteAria": "Delete result",
				"deleteDisabledTooltip": "Results linked to consultations can only be changed or removed in the consultation."
			},
			"origin": {
				"manual": "Manual",
				"visit": "Consultation"
			},
			"testsMore": "+ {count} exams",
			"testsMoreSingular": "+ {count} exam",
			"delete": {
				"title": "Delete exam result?",
				"content": "This action cannot be undone.",
				"confirm": "Delete",
				"cancel": "Cancel",
				"success": "Result deleted.",
				"error": "Could not delete the result."
			},
			"fallback": {
				"exam": "Exam",
				"panel": "Panel",
				"exams": "Exams",
				"request": "Request",
				"noRef": "No reference",
				"noValue": "No value",
				"inRange": "In range",
				"low": "Low",
				"high": "High",
				"noRefShort": "No ref.",
				"improving": "Improving",
				"worsening": "Worsening",
				"stable": "Stable",
				"noBaseline": "No baseline"
			},
			"referenceDisclaimer": "Reference ranges are informational and do not replace clinical judgment or diagnose on their own.",
			"compare": {
				"filters": {
					"examLabel": "Exam / panel",
					"examPlaceholder": "Search exam or panel",
					"panelLabel": "Panel",
					"panelPlaceholder": "Filter by panel",
					"fromLabel": "From",
					"toLabel": "To",
					"clear": "Clear",
					"rangeLabel": "Reference range",
					"rangePlaceholder": "All ranges",
					"rangeIn": "In range",
					"rangeOut": "Out of range (high or low)",
					"rangeLow": "Below range",
					"rangeHigh": "Above range",
					"onlyRepeated": "Only exams with more than one occurrence"
				},
				"metrics": {
					"exams": "exams",
					"out": "out",
					"inRange": "in range",
					"last": "last",
					"missingPartial": "{count} exams missing records",
					"neverRecorded": "{count} exams with no records"
				},
				"empty": {
					"title": "No exams performed",
					"description": "Here you will see the comparison of exam values to track your pet's progress!"
				},
				"card": {
					"ref": "Ref:",
					"lastValue": "Last value",
					"chartAria": "Exam progress",
					"noChartData": "No numeric data for a chart.",
					"date": "Date",
					"value": "Value",
					"panel": "Panel"
				},
				"errors": {
					"load": "Could not load the comparison."
				}
			},
			"details": {
				"tabs": {
					"aria": "Exam result sections",
					"info": "Request",
					"values": "Values",
					"documents": "Reports"
				},
				"meta": {
					"saveError": "Could not save the request details."
				},
				"visit": {
					"consultation": "Request date",
					"clinic": "Clinic",
					"vet": "Veterinarian"
				},
				"itemsCount": "items",
				"columns": {
					"exam": "Exam",
					"reference": "Reference",
					"value": "Value",
					"performed": "Performed",
					"resulted": "Result",
					"actions": "Actions"
				},
				"edit": {
					"numeric": "Numeric",
					"text": "Text",
					"refLow": "Min.",
					"refHigh": "Max.",
					"refText": "Ref. (text)",
					"reportText": "Report / description",
					"conclusion": "Conclusion",
					"reportShort": "Report",
					"notPerformed": "Not performed",
					"valueNumPlaceholder": "Enter the value",
					"valueTextPlaceholder": "Enter the result",
					"resetReference": "Reset reference"
				},
				"status": {
					"label": "Status",
					"PENDING": "Pending",
					"PARTIAL": "Partial",
					"DONE": "Done"
				},
				"panelReport": {
					"title": "Panel report"
				},
				"requestReport": {
					"title": "Request report / result"
				},
				"availability": {
					"NO_RESULT": "No result",
					"DOCUMENT_ONLY": "Document only",
					"STRUCTURED": "Structured",
					"HYBRID": "Hybrid"
				},
				"documentOnlyEmpty": "Result attached — no structured data for comparison.",
				"noStructuredItems": "No structured exams in this request.",
				"documents": {
					"title": "Attached files",
					"upload": "Attach report (PDF or image)",
					"extractPdf": "Extract from PDF",
					"empty": "No files attached to this result.",
					"openError": "Could not open the file.",
					"itemTitle": "Item report",
					"uploadHint": "Upload a PDF or image. If OCR recognizes text, we suggest structured items; otherwise the file is stored on the report."
				},
				"ocr": {
					"title": "Extraction review",
					"hint": "Confirm, edit or ignore each row before applying to the order.",
					"empty": "No exam lines found in the PDF (it may have no text layer).",
					"warning": "Extraction with warnings: {message}",
					"failed": "Extraction failed: {message}",
					"suggested": "Suggestion",
					"value": "Value",
					"unit": "Unit",
					"confirm": "Confirm",
					"ignore": "Ignore",
					"edit": "Edit",
					"apply": "Apply confirmed",
					"applying": "Applying…",
					"extracting": "Extracting…",
					"status": {
						"PENDING": "Pending",
						"CONFIRMED": "Confirmed",
						"EDITED": "Edited",
						"IGNORED": "Ignored",
						"CUSTOM": "Custom"
					},
					"errors": {
						"extract": "Could not extract the PDF.",
						"apply": "Could not apply the extraction.",
						"patch": "Could not update the review."
					}
				},
				"addExam": "Add exam",
				"addExamHintVisit": "To add exams linked to a consultation, edit the consultation.",
				"addExamPlaceholder": "Search exam or panel…",
				"origin": {
					"visitHint": "Origin: visit — read-only fields"
				}
			},
			"errors": {
				"load": "Could not load exams."
			},
			"form": {
				"performedAt": "Performed date",
				"veterinarian": "Veterinarian",
				"veterinarianPlaceholder": "Select veterinarian",
				"vetName": "Veterinarian name",
				"vetNamePlaceholder": "Name",
				"vetCrmv": "License (CRMV)",
				"vetCrmvPlaceholder": "License",
				"clinic": "Clinic / lab",
				"clinicPlaceholder": "Select clinic",
				"clinicName": "Clinic name",
				"clinicNamePlaceholder": "Name",
				"notes": "Notes / method",
				"notesPlaceholder": "Method, lab, notes…",
				"examRequests": "Exams and panels",
				"examRequestsPlaceholder": "Select exams or panels",
				"valuesTitle": "Values",
				"valuesHint": "Fill values now or later in details. Each value is saved individually.",
				"valueNum": "Numeric value",
				"valueText": "Text value",
				"upload": "Result attachments",
				"success": {
					"create": "Exam result saved.",
					"update": "Exam result updated."
				},
				"errors": {
					"load": "Could not load the exam form.",
					"save": "Could not save the exam result.",
					"examsOrUpload": "Select at least one exam/panel or attach a file."
				}
			},
			"filters": {
				"statusLabel": "Status",
				"statusPlaceholder": "Filter by status",
				"originLabel": "Origin",
				"originPlaceholder": "Manual or visit",
				"examLabel": "Exam / panel",
				"examPlaceholder": "Search by exam, panel or item (e.g. Monocytes)"
			}
		},
		"petAccess": {
			"title": "Veterinarian access",
			"loading": "Loading access",
			"fallbackInvite": "Invite",
			"invite": {
				"title": "Invite veterinarian",
				"nameLabel": "Name",
				"namePlaceholder": "E.g. Dr. Ana",
				"emailLabel": "Email",
				"emailPlaceholder": "email@example.com",
				"submit": "Send invite",
				"hint": "The veterinarian will receive a link to accept access.",
				"sent": "Invite sent.",
				"resent": "Invite resent."
			},
			"filters": {
				"searchLabel": "Search",
				"searchPlaceholder": "Filter by name or email",
				"kindLabel": "Type",
				"kindPlaceholder": "Which",
				"kindAccess": "Access",
				"kindInvite": "Invites",
				"kindClearAria": "Clear type",
				"statusLabel": "Status",
				"statusPlaceholder": "Status",
				"statusClearAria": "Clear status",
				"onlyActiveAccess": "Show only active access"
			},
			"status": {
				"active": "Active",
				"blocked": "Blocked",
				"pending": "Pending",
				"expired": "Expired",
				"accepted": "Accepted",
				"revoked": "Revoked",
				"vetRejected": "Declined by veterinarian"
			},
			"columns": {
				"name": "Name",
				"kind": "Type",
				"email": "Email",
				"status": "Status",
				"actions": "Actions"
			},
			"empty": {
				"title": "No veterinarians or invites found",
				"description": "Invite a veterinarian to follow your pet's health."
			},
			"noResults": {
				"title": "No results found",
				"description": "Try adjusting the filters to find what you are looking for."
			},
			"actions": {
				"activateAria": "Activate access",
				"blockAria": "Block access",
				"unblockAria": "Unblock access",
				"removeAria": "Remove access",
				"cancelInviteAria": "Cancel invite",
				"resendInviteAria": "Resend invite"
			},
			"modal": {
				"cancel": "Cancel"
			},
			"revokeInvite": {
				"title": "Cancel invite?",
				"contentWithEmail": "Are you sure you want to cancel the invite for \"{email}\"?",
				"contentGeneric": "Are you sure you want to cancel this invite?",
				"confirm": "Cancel invite",
				"success": "Invite cancelled."
			},
			"removeAccess": {
				"title": "Remove access?",
				"contentWithName": "Are you sure you want to remove access for \"{name}\"?",
				"contentGeneric": "Are you sure you want to remove this access?",
				"confirm": "Remove",
				"success": "Access removed."
			},
			"errors": {
				"load": "Could not load access.",
				"invite": "Could not send the invite.",
				"inviteAlreadySent": "This pet already has a pending invite for this email.",
				"alreadyHasAccess": "This email already has access to this pet.",
				"resend": "Could not resend the invite.",
				"updateStatus": "Could not update access.",
				"revokeInvite": "Could not cancel the invite.",
				"removeAccess": "Could not remove access."
			}
		},
		"settings": {
			"shared": {
				"species": {
					"dog": "Dog",
					"cat": "Cat",
					"dog_cat": "Dog and Cat",
					"other": "Other"
				},
				"sex": {
					"male": "Male",
					"female": "Female",
					"notDeclared": "Not informed"
				},
				"examKinds": {
					"BLOOD": "Blood",
					"URINE": "Urine",
					"FECES": "Feces",
					"IMAGE": "Imaging",
					"CYTOLOGY": "Cytology",
					"HISTOPATHOLOGY": "Histopathology",
					"MICROBIOLOGY": "Microbiology",
					"RAPID_TEST": "Rapid test",
					"GENETIC": "Genetic",
					"CARDIOLOGY": "Cardiology",
					"OTHER": "Other"
				},
				"fasting": {
					"NO": "No",
					"YES": "Yes",
					"PREFERRED": "Preferably yes",
					"NOT_APPLICABLE": "Not applicable",
					"VARIABLE": "Variable",
					"NAO": "No",
					"SIM": "Yes",
					"PREFERENCIALMENTE_SIM": "Preferably yes"
				},
				"labSpecies": {
					"DOG": "Dog",
					"CAT": "Cat"
				},
				"labTestStatuses": {
					"DRAFT": "Draft",
					"ACTIVE": "Active",
					"INACTIVE": "Inactive",
					"DEPRECATED": "Deprecated"
				},
				"resultTypes": {
					"NUMERIC": "Numeric",
					"QUALITATIVE": "Qualitative",
					"ORDINAL": "Ordinal",
					"BOOLEAN": "Boolean",
					"TEXT": "Text",
					"REPORT": "Report",
					"COMPOSITE": "Composite",
					"UNSPECIFIED": "Unspecified"
				}
			},
			"vaccineTypes": {
				"close": "Close",
				"loading": "Loading vaccine catalog",
				"tabs": {
					"aria": "Vaccine catalog",
					"kinds": "Types",
					"brands": "Brands",
					"products": "Products",
					"others": "Others"
				},
				"yes": "Yes",
				"no": "No",
				"active": "Active",
				"inactive": "Inactive",
				"filters": {
					"showDeleted": "Show deleted"
				},
				"actions": {
					"delete": "Delete",
					"deleteAria": "Delete catalog item",
					"restore": "Restore",
					"restoreAria": "Restore catalog item",
					"cancel": "Cancel"
				},
				"delete": {
					"title": "Delete catalog item?",
					"content": "This will mark \"{name}\" as deleted. It will no longer appear in default lists.",
					"success": "Item deleted."
				},
				"restore": {
					"title": "Restore catalog item?",
					"content": "This will restore \"{name}\" to default lists.",
					"success": "Item restored."
				},
				"errors": {
					"delete": "Could not delete the item.",
					"restore": "Could not restore the item."
				},
				"kinds": {
					"loading": "Loading types",
					"form": {
						"createTitle": "Register vaccine type",
						"editTitle": "Edit vaccine type",
						"codeLabel": "Code",
						"codePlaceholder": "E.g.: RABIES",
						"nameLabel": "Default name",
						"boosterGroupLabel": "Booster group",
						"boosterGroupPlaceholder": "Select group",
						"boosterGroupOther": "Other (enter code)",
						"boosterGroupOtherCodeLabel": "Group code",
						"boosterGroupOtherCodePlaceholder": "e.g. canine-polyvalent",
						"speciesLabel": "Species",
						"diseasesLabel": "Covered diseases",
						"diseasesPlaceholder": "Select diseases",
						"diseasesEmpty": "No diseases found",
						"isOtherLabel": "\"Other\" type",
						"alertsEnabledLabel": "Generate booster alerts",
						"activeLabel": "Active",
						"descriptionLabel": "Description",
						"descriptionPlaceholder": "Write the description",
						"save": "Save",
						"cancel": "Cancel"
					},
					"filters": {
						"nameLabel": "Search",
						"namePlaceholder": "Code or name",
						"speciesLabel": "Species",
						"speciesPlaceholder": "Species",
						"speciesClearAria": "Clear species"
					},
					"columns": {
						"code": "Code",
						"name": "Name",
						"boosterGroup": "Booster group",
						"species": "Species",
						"diseases": "Diseases",
						"isOther": "Other",
						"active": "Active",
						"actions": "Actions"
					},
					"empty": {
						"title": "No types registered",
						"description": "Register the system vaccine types."
					},
					"noResults": {
						"title": "No types found",
						"description": "Try adjusting the filters to find what you are looking for."
					},
					"actions": {
						"editAria": "Edit type"
					},
					"errors": {
						"load": "Could not load vaccine types.",
						"save": "Could not save the vaccine type.",
						"speciesRequired": "Select at least one species.",
						"boosterGroupRequired": "Enter the booster group."
					},
					"boosterGroups": {
						"canine-polyvalent": "Canine polyvalent",
						"feline-polyvalent": "Feline polyvalent"
					}
				},
				"brands": {
					"loading": "Loading brands",
					"form": {
						"createTitle": "Register brand",
						"editTitle": "Edit brand",
						"nameLabel": "Name",
						"activeLabel": "Active",
						"save": "Save",
						"cancel": "Cancel"
					},
					"filters": {
						"nameLabel": "Search",
						"namePlaceholder": "Brand name"
					},
					"columns": {
						"name": "Name",
						"active": "Active",
						"actions": "Actions"
					},
					"empty": {
						"title": "No brands registered",
						"description": "Register commercial vaccine brands."
					},
					"noResults": {
						"title": "No brands found",
						"description": "Try adjusting the filters to find what you are looking for."
					},
					"actions": {
						"editAria": "Edit brand"
					},
					"errors": {
						"load": "Could not load brands.",
						"save": "Could not save the brand."
					}
				},
				"products": {
					"loading": "Loading products",
					"form": {
						"createTitle": "Register product",
						"editTitle": "Edit product",
						"kindLabel": "Type",
						"kindPlaceholder": "Select type",
						"brandLabel": "Brand",
						"brandPlaceholder": "Select brand",
						"nameLabel": "Commercial name",
						"speciesLabel": "Species",
						"isOtherLabel": "\"Other\" product",
						"activeLabel": "Active",
						"notesLabel": "Notes",
						"notesPlaceholder": "Write notes",
						"save": "Save",
						"cancel": "Cancel"
					},
					"filters": {
						"nameLabel": "Search",
						"namePlaceholder": "Commercial name",
						"kindLabel": "Type",
						"kindPlaceholder": "Type",
						"kindClearAria": "Clear type",
						"speciesLabel": "Species",
						"speciesPlaceholder": "Species",
						"speciesClearAria": "Clear species"
					},
					"columns": {
						"name": "Commercial name",
						"kind": "Type",
						"brand": "Brand",
						"species": "Species",
						"isOther": "Other",
						"active": "Active",
						"actions": "Actions"
					},
					"empty": {
						"title": "No products registered",
						"description": "Register commercial vaccine products."
					},
					"noResults": {
						"title": "No products found",
						"description": "Try adjusting the filters to find what you are looking for."
					},
					"actions": {
						"editAria": "Edit product"
					},
					"errors": {
						"load": "Could not load products.",
						"save": "Could not save the product.",
						"speciesRequired": "Select at least one species."
					}
				},
				"others": {
					"loading": "Loading others queue",
					"filters": {
						"statusLabel": "Status"
					},
					"status": {
						"open": "Open",
						"promoted": "Promoted",
						"dismissed": "Dismissed",
						"all": "All"
					},
					"columns": {
						"type": "Type",
						"rawText": "Text",
						"applicationCount": "Occurrences",
						"actions": "Actions"
					},
					"typeKind": "Vaccine type",
					"typeProduct": "Product",
					"actions": {
						"promote": "Promote",
						"dismiss": "Dismiss"
					},
					"form": {
						"codeLabel": "Code",
						"nameLabel": "Default name",
						"commercialNameLabel": "Commercial name",
						"kindLabel": "Vaccine type",
						"kindPlaceholder": "Select type",
						"speciesLabel": "Species",
						"cancel": "Cancel",
						"confirmPromote": "Confirm"
					},
					"empty": {
						"title": "No items in the queue",
						"description": "Free-text vaccine entries will appear here for review."
					},
					"noResults": {
						"title": "No items found",
						"description": "Try adjusting the status filter."
					},
					"errors": {
						"load": "Could not load the others queue.",
						"dismiss": "Could not dismiss the item.",
						"promote": "Could not promote the item.",
						"speciesRequired": "Select at least one species.",
						"kindRequired": "Select the vaccine type."
					}
				}
			},
			"diseases": {
				"close": "Close",
				"loading": "Loading diseases",
				"form": {
					"createTitle": "Register disease",
					"editTitle": "Edit disease",
					"codeLabel": "Code",
					"codePlaceholder": "E.g.: RABIES",
					"nameLabel": "Default name",
					"activeLabel": "Active",
					"save": "Save",
					"cancel": "Cancel"
				},
				"filters": {
					"nameLabel": "Search",
					"namePlaceholder": "Code or name",
					"showDeleted": "Show deleted"
				},
				"columns": {
					"code": "Code",
					"name": "Name",
					"active": "Active",
					"actions": "Actions"
				},
				"empty": {
					"title": "No diseases registered",
					"description": "Register diseases to link to vaccines, diagnoses and conditions."
				},
				"noResults": {
					"title": "No diseases found",
					"description": "Try adjusting the filters to find what you are looking for."
				},
				"actions": {
					"editAria": "Edit disease",
					"delete": "Delete",
					"deleteAria": "Delete disease",
					"restore": "Restore",
					"restoreAria": "Restore disease",
					"cancel": "Cancel"
				},
				"delete": {
					"title": "Delete disease?",
					"content": "This will mark \"{name}\" as deleted.",
					"success": "Disease deleted."
				},
				"restore": {
					"title": "Restore disease?",
					"content": "This will restore \"{name}\".",
					"success": "Disease restored."
				},
				"errors": {
					"load": "Could not load diseases.",
					"save": "Could not save the disease.",
					"delete": "Could not delete the disease.",
					"restore": "Could not restore the disease."
				}
			},
			"breeds": {
				"title": "Breeds and coat",
				"subtitle": "Browse breeds, manage coat colors, and review free-text entries marked as Other",
				"close": "Close alert",
				"tabs": {
					"aria": "Breed sections",
					"catalog": "Breeds",
					"reference": "Coat",
					"others": "Others"
				},
				"catalog": {
					"loading": "Loading breeds",
					"filters": {
						"species": "Species",
						"search": "Search",
						"searchPlaceholder": "Name or code"
					},
					"columns": {
						"code": "Code",
						"name": "Name",
						"group": "Group"
					},
					"empty": {
						"title": "No breeds found",
						"description": "Adjust the filters or select another species."
					},
					"noResults": {
						"title": "No results",
						"description": "No breeds match the current filters."
					},
					"errors": {
						"load": "Could not load breeds.",
						"save": "Could not save the breed.",
						"codeExists": "A breed with this code already exists for the species."
					},
					"saveSuccess": "Breed created successfully.",
					"form": {
						"createTitle": "Add breed",
						"speciesLabel": "Species",
						"codeLabel": "Code",
						"codePlaceholder": "e.g. LABRADOR",
						"nameLabel": "Name",
						"namePlaceholder": "Display name",
						"save": "Save"
					}
				},
				"colors": {
					"loading": "Loading colors",
					"filterTipo": "colors",
					"saveSuccess": "Color saved successfully.",
					"deleteSuccess": "Color removed successfully.",
					"restoreSuccess": "Color restored successfully.",
					"filters": {
						"search": "Search",
						"searchPlaceholder": "Name or code",
						"showDeleted": "Show removed"
					},
					"form": {
						"createTitle": "Add new color",
						"editTitle": "Edit color",
						"codeLabel": "Code",
						"codePlaceholder": "e.g. merle",
						"nameLabel": "Name",
						"namePlaceholder": "Display name",
						"sortOrderLabel": "Order",
						"activeLabel": "Active",
						"save": "Save",
						"cancel": "Cancel"
					},
					"columns": {
						"code": "Code",
						"name": "Name",
						"sortOrder": "Order",
						"active": "Active",
						"actions": "Actions"
					},
					"actions": {
						"editAria": "Edit color",
						"deleteAria": "Remove color",
						"restoreAria": "Restore color",
						"delete": "Remove",
						"restore": "Restore",
						"cancel": "Cancel"
					},
					"delete": {
						"title": "Remove color",
						"content": "Remove the color \"{{name}}\"? Pets that already use this color keep the saved value."
					},
					"restore": {
						"title": "Restore color",
						"content": "Restore the color \"{{name}}\"?"
					},
					"empty": {
						"title": "No colors registered",
						"description": "Add the first coat color."
					},
					"noResults": {
						"title": "No results",
						"description": "No colors match the current filters."
					},
					"errors": {
						"load": "Could not load colors.",
						"save": "Could not save the color.",
						"delete": "Could not remove the color.",
						"restore": "Could not restore the color."
					}
				},
				"others": {
					"loading": "Loading review queue",
					"filters": {
						"species": "Species",
						"status": "Status",
						"allSpecies": "All species"
					},
					"columns": {
						"text": "Entered text",
						"species": "Species",
						"pets": "Pets",
						"status": "Status",
						"actions": "Actions"
					},
					"status": {
						"open": "Open",
						"promoted": "Promoted",
						"dismissed": "Dismissed",
						"all": "All"
					},
					"actions": {
						"promote": "Promote",
						"dismiss": "Dismiss"
					},
					"promote": {
						"code": "Code",
						"name": "Name",
						"species": "Species",
						"create": "Create breed",
						"linkExisting": "Link to existing breed",
						"link": "Link",
						"cancel": "Cancel"
					},
					"empty": {
						"title": "Queue is empty",
						"description": "Free-text entries marked as Other will appear here for review."
					},
					"noResults": {
						"title": "No results",
						"description": "No items match the current filters."
					},
					"promoteSuccess": "Breed promoted successfully.",
					"dismissSuccess": "Item dismissed.",
					"errors": {
						"load": "Could not load the review queue.",
						"promote": "Could not promote this item.",
						"dismiss": "Could not dismiss this item."
					}
				}
			},
			"examTypes": {
				"close": "Close",
				"loading": "Loading exam types",
				"disclaimer": "Reference ranges are informational and do not replace clinical judgment or diagnose on their own.",
				"form": {
					"createTitle": "Register exam type",
					"editTitle": "Edit exam type",
					"nameLabel": "Common name",
					"namePlaceholder": "E.g. Glucose, SDMA, ALT",
					"officialNameLabel": "Official name",
					"officialNamePlaceholder": "E.g. Serum glucose",
					"codeLabel": "Code",
					"codePlaceholder": "E.g. GLU-SER",
					"categoryLabel": "Category (legacy text)",
					"categoryIdLabel": "Category",
					"categoryIdPlaceholder": "Select category",
					"subcategoryIdLabel": "Subcategory",
					"subcategoryIdPlaceholder": "Select subcategory",
					"speciesLabel": "Species",
					"speciesPlaceholder": "Species",
					"speciesCodesLabel": "Applicable species",
					"speciesRequiredError": "Select at least one species.",
					"examKindLabel": "Exam kind",
					"examKindPlaceholder": "Exam kind",
					"statusLabel": "Status",
					"resultTypeLabel": "Result type",
					"aliasesLabel": "Aliases / synonyms",
					"aliasesPlaceholder": "Comma-separated",
					"tagsLabel": "Tags",
					"tagsPlaceholder": "Comma-separated",
					"resultOptionsLabel": "Qualitative options",
					"resultOptionsPlaceholder": "E.g. Negative, Positive, Indeterminate",
					"replacementLabel": "Replacement exam (deprecated)",
					"replacementPlaceholder": "Select canonical exam",
					"unitLabel": "Unit",
					"refDogTitle": "Reference — dog",
					"refCatTitle": "Reference — cat",
					"refLowLabel": "Minimum",
					"refHighLabel": "Maximum",
					"refTextLabel": "Reference text",
					"refNotesLabel": "Reference notes",
					"fastingRequiredLabel": "Fasting required?",
					"fastingRequiredPlaceholder": "Fasting",
					"fastingTimeLabel": "Fasting time",
					"fastingTimePlaceholder": "E.g. 8 to 12 hours",
					"fastingMinLabel": "Min fasting (min)",
					"fastingMaxLabel": "Max fasting (min)",
					"descriptionLabel": "Description",
					"descriptionPlaceholder": "Technical description",
					"preparationInformationLabel": "Preparation information",
					"preparationInformationPlaceholder": "Patient preparation guidance",
					"additionalInfoLabel": "Catalog information",
					"additionalInfoPlaceholder": "Notes for the catalog...",
					"reviewRequiredLabel": "Review required",
					"routineLabel": "Routine",
					"sortOrderLabel": "Sort order",
					"save": "Save",
					"cancel": "Cancel",
					"softDelete": "Delete (deactivate)",
					"deactivate": "Delete (deactivate)",
					"saveSuccess": "Exam type saved successfully.",
					"updateSuccess": "Exam type updated successfully.",
					"softDeleteSuccess": "Exam type deleted (deactivated).",
					"deactivateSuccess": "Exam type deleted (deactivated)."
				},
				"filters": {
					"nameLabel": "Exam name",
					"namePlaceholder": "Name (common or official)",
					"speciesLabel": "Species",
					"speciesPlaceholder": "Species",
					"speciesClearAria": "Clear species",
					"examKindLabel": "Exam kind",
					"statusLabel": "Status",
					"includeInactive": "Include inactive",
					"includeDeprecated": "Include deprecated"
				},
				"columns": {
					"name": "Name",
					"officialName": "Official name",
					"status": "Status",
					"species": "Species",
					"examKind": "Exam kind",
					"unit": "Unit",
					"reference": "Reference",
					"category": "Category",
					"additionalInfo": "Additional info",
					"actions": "Actions"
				},
				"empty": {
					"title": "No exam types registered",
					"description": "Register exam types so they can be found in the system."
				},
				"noResults": {
					"title": "No exam types found",
					"description": "Try adjusting the filters."
				},
				"actions": {
					"editAria": "Edit exam type",
					"duplicateAria": "Duplicate exam type",
					"softDeleteAria": "Delete exam type"
				},
				"errors": {
					"load": "Could not load exam types.",
					"save": "Could not save exam type.",
					"softDelete": "Could not delete exam type.",
					"deactivate": "Could not delete exam type."
				}
			},
			"examPanels": {
				"close": "Close",
				"loading": "Loading exam panels",
				"form": {
					"createTitle": "Register exam panel",
					"editTitle": "Edit exam panel",
					"nameLabel": "Panel name",
					"officialNameLabel": "Official name",
					"officialNamePlaceholder": "Official panel name",
					"codeLabel": "Code",
					"codePlaceholder": "E.g. PANEL-BIOQ",
					"statusLabel": "Status",
					"speciesLabel": "Species (legacy)",
					"speciesPlaceholder": "Species",
					"speciesCodesLabel": "Applicable species",
					"speciesRequiredError": "Select at least one species.",
					"examKindLabel": "Exam kind",
					"examKindPlaceholder": "Exam kind",
					"categoryIdLabel": "Category",
					"categoryIdPlaceholder": "Select category",
					"fastingRequiredLabel": "Fasting required?",
					"fastingRequiredPlaceholder": "Fasting",
					"fastingTimeLabel": "Fasting time",
					"fastingTimePlaceholder": "E.g. 8 to 12 hours",
					"fastingMinLabel": "Min fasting (min)",
					"fastingMaxLabel": "Max fasting (min)",
					"descriptionLabel": "Description",
					"descriptionPlaceholder": "Panel description",
					"reviewRequiredLabel": "Review required",
					"sortOrderLabel": "Sort order",
					"itemsTitle": "Exams included in the panel",
					"itemTypeLabel": "Exam type",
					"itemTypePlaceholder": "Select exam type",
					"itemTypeEmpty": "No exam type available",
					"itemRequiredLabel": "Required",
					"itemDefaultLabel": "Selected by default",
					"addItem": "Add to panel",
					"itemsEmpty": "No exams added to the panel.",
					"tagRequired": "Required",
					"tagDefault": "Selected by default",
					"saveSuccess": "Exam panel saved successfully.",
					"updateSuccess": "Exam panel updated successfully.",
					"softDelete": "Delete (deactivate)",
					"softDeleteSuccess": "Exam panel deleted (deactivated).",
					"removeItem": "Remove",
					"moveItemUp": "Move exam up",
					"moveItemDown": "Move exam down",
					"save": "Save",
					"cancel": "Cancel"
				},
				"filters": {
					"nameLabel": "Panel name",
					"namePlaceholder": "Panel name",
					"speciesLabel": "Species",
					"speciesPlaceholder": "Species",
					"speciesClearAria": "Clear species",
					"examKindLabel": "Exam kind",
					"examKindPlaceholder": "Exam kind",
					"examKindClearAria": "Clear exam kind",
					"statusLabel": "Status",
					"includeInactive": "Include inactive",
					"includeDeprecated": "Include deprecated"
				},
				"columns": {
					"name": "Name",
					"species": "Species",
					"examKind": "Exam kind",
					"status": "Status",
					"itemsCount": "Exam count",
					"description": "Description",
					"actions": "Actions"
				},
				"empty": {
					"title": "No exam panels registered",
					"description": "Register panels so exams can be found in the system."
				},
				"noResults": {
					"title": "No panels found",
					"description": "Try adjusting the filters."
				},
				"actions": {
					"editAria": "Edit exam panel",
					"softDeleteAria": "Delete exam panel"
				},
				"errors": {
					"load": "Could not load exam panels.",
					"save": "Could not save exam panel.",
					"softDelete": "Could not delete exam panel."
				}
			},
			"exams": {
				"tabs": {
					"aria": "Exam administration sections",
					"catalog": "Catalog",
					"panels": "Panels",
					"audit": "Audit",
					"imports": "Imports",
					"auditComingSoon": "Exam audit will be available in a later step.",
					"importsComingSoon": "Spreadsheet/PDF imports will be available in later steps."
				},
				"audit": {
					"disclaimer": "Review exams tutors requested as “Other”. Create or merge promotes to the official catalog and relinks requests; reject keeps the original text without promoting.",
					"loading": "Loading audit queue",
					"createSuccess": "Official type created and entry resolved.",
					"mergeSuccess": "Entry merged into the official type.",
					"rejectSuccess": "Entry rejected.",
					"reopenSuccess": "Entry reopened for review.",
					"mergeTargetAria": "Official exam type to merge into",
					"mergeTargetPlaceholder": "Search official exam…",
					"filters": {
						"status": "Status",
						"q": "Search",
						"qPlaceholder": "Original name"
					},
					"columns": {
						"name": "Original name",
						"status": "Status",
						"kind": "Suggested kind",
						"official": "Official",
						"updatedAt": "Updated",
						"actions": "Actions"
					},
					"actions": {
						"create": "Create official",
						"merge": "Merge",
						"reject": "Reject",
						"reopen": "Reopen"
					},
					"status": {
						"pending": "Pending",
						"created": "Created",
						"merged": "Merged",
						"rejected": "Rejected",
						"all": "All"
					},
					"empty": {
						"title": "No entries",
						"description": "When tutors request exams outside the catalog, they will appear here."
					},
					"errors": {
						"load": "Could not load the audit queue.",
						"create": "Could not create the official type.",
						"merge": "Could not merge the entry.",
						"mergeTarget": "Enter the official type ID to merge.",
						"reject": "Could not reject the entry.",
						"reopen": "Could not reopen the entry."
					},
					"mergeTargetEmpty": "No exams found"
				},
				"imports": {
					"disclaimer": "Import the catalog as CSV or JSON, review classifications, and apply per-row actions. Template v1 does not include XLSX.",
					"loading": "Loading imports",
					"uploadSuccess": "File uploaded and classified successfully.",
					"actionsSaved": "Row actions saved.",
					"applySuccess": "Import applied successfully.",
					"emptyRows": "No rows in this import.",
					"columns": {
						"filename": "File",
						"status": "Status",
						"totals": "Summary",
						"createdAt": "Created at",
						"actions": "Actions"
					},
					"actions": {
						"downloadTemplate": "Download template",
						"upload": "Upload file",
						"saveRows": "Save actions",
						"apply": "Apply import",
						"openAria": "Open import details",
						"create": "Create",
						"update": "Update",
						"ignore": "Ignore",
						"link": "Link"
					},
					"status": {
						"readyForReview": "Ready for review",
						"processing": "Processing",
						"applied": "Applied",
						"failed": "Failed",
						"cancelled": "Cancelled"
					},
					"classification": {
						"new": "New",
						"identical": "Identical",
						"different": "Different",
						"possibleDuplicate": "Possible duplicate",
						"invalid": "Invalid"
					},
					"empty": {
						"title": "No imports yet",
						"description": "Download the template and upload a CSV or JSON file to get started."
					},
					"errors": {
						"load": "Could not load imports.",
						"template": "Could not download the template.",
						"upload": "Could not upload the file.",
						"detail": "Could not open import details.",
						"saveRows": "Could not save row actions.",
						"apply": "Could not apply the import."
					},
					"hints": {
						"create": "Suggestion: create in catalog",
						"update": "Suggestion: update the matched exam",
						"link": "Suggestion: link / review duplicate",
						"ignore": "Suggestion: ignore"
					},
					"compare": {
						"matched": "Matches",
						"field": "Field",
						"incoming": "Imported",
						"catalog": "Current catalog",
						"fields": {
							"code": "Code",
							"name": "Name",
							"officialName": "Official name",
							"examKind": "Kind",
							"status": "Status",
							"resultType": "Result type",
							"unit": "Unit",
							"refLow": "Ref. low",
							"refHigh": "Ref. high",
							"category": "Category",
							"fastingRequirement": "Fasting",
							"description": "Description",
							"additionalInfo": "Additional info",
							"species": "Species"
						}
					},
					"actionHelp": {
						"createHelp": "Creates a new catalog exam using the Imported column values.",
						"updateHelp": "Overwrites the matched catalog exam with the Imported values.",
						"ignoreHelp": "Does nothing to the catalog; the imported row is discarded.",
						"linkHelp": "Not really implemented yet (currently behaves like Ignore). Tell us how it should work."
					}
				}
			},
			"systemUsers": {
				"loading": "Loading users",
				"filters": {
					"searchLabel": "Search",
					"searchPlaceholder": "Name, email, phone",
					"roleLabel": "Type",
					"rolePlaceholder": "All",
					"roleClearAria": "Clear type",
					"showDeleted": "Show deleted"
				},
				"roles": {
					"user": "Owner",
					"vet": "Veterinarian",
					"master": "Master"
				},
				"status": {
					"active": "Active",
					"pendingVerification": "Pending verification",
					"blocked": "Blocked",
					"deleted": "Deleted"
				},
				"columns": {
					"name": "Name",
					"email": "Email",
					"role": "Type",
					"pets": "Pets",
					"status": "Status",
					"createdAt": "Created",
					"actions": "Actions"
				},
				"empty": {
					"title": "No users registered",
					"description": "Users will appear here soon! :)"
				},
				"noResults": {
					"title": "No users found",
					"description": "Try adjusting the filters to find what you are looking for."
				},
				"actions": {
					"restoreAria": "Restore user",
					"deleteForeverAria": "Delete permanently",
					"blockAria": "Block user",
					"unblockAria": "Unblock user",
					"deleteAria": "Delete user",
					"resendVerificationAria": "Resend verification email"
				},
				"modal": {
					"cancel": "Cancel"
				},
				"delete": {
					"title": "Delete user",
					"content": "This will mark the user as deleted and soft-delete their pets. Continue?\n\n{name}\n{email}",
					"confirm": "Delete"
				},
				"deleteForever": {
					"title": "Delete permanently",
					"content": "This action is permanent and removes the user from the database.\n\n{name}\n{email}",
					"confirm": "Delete permanently"
				},
				"restore": {
					"title": "Restore user",
					"content": "This will restore the user and the pets deactivated with that deletion. Continue?\n\n{name}\n{email}",
					"confirm": "Restore"
				},
				"success": {
					"resendVerification": "Verification email resent."
				},
				"errors": {
					"load": "Could not load users.",
					"updateStatus": "Could not update user status.",
					"delete": "Could not delete the user.",
					"deleteForever": "Could not permanently delete the user.",
					"restore": "Could not restore the user.",
					"resendVerification": "Could not resend the verification email."
				}
			},
			"audit": {
				"loading": "Loading audit logs",
				"filters": {
					"sourceLabel": "Source",
					"sourceAuth": "Authentication",
					"sourceActions": "Admin actions",
					"emailLabel": "Email",
					"emailPlaceholder": "Filter by email",
					"eventLabel": "Event",
					"eventPlaceholder": "Filter by event",
					"actionLabel": "Action",
					"actionPlaceholder": "Filter by action",
					"entityTypeLabel": "Entity type",
					"entityTypePlaceholder": "Filter by entity type"
				},
				"columns": {
					"event": "Event",
					"email": "Email",
					"userId": "User",
					"action": "Action",
					"entityType": "Type",
					"entityId": "Entity ID",
					"entityName": "Entity",
					"actorUserId": "Actor ID",
					"actorName": "Actor",
					"ip": "IP",
					"country": "Country",
					"createdAt": "Date",
					"actions": "Actions"
				},
				"empty": {
					"title": "No audit records",
					"description": "Authentication and admin action logs will appear here."
				},
				"noResults": {
					"title": "No records found",
					"description": "Try adjusting the filters to find what you are looking for."
				},
				"actions": {
					"metadataAria": "View metadata"
				},
				"metadata": {
					"title": "Metadata",
					"close": "Close"
				},
				"errors": {
					"load": "Could not load audit records."
				}
			},
			"dashboard": {
				"close": "Close",
				"loading": "Loading dashboard",
				"refreshing": "Updating data…",
				"tabs": {
					"aria": "Admin dashboard tabs",
					"pets": "Pets",
					"vaccines": "Vaccines",
					"others": "Others",
					"exams": "Exams"
				},
				"period": {
					"from": "From",
					"to": "To",
					"apply": "Apply",
					"petsHint": "Filters by pet registration period and tutor. Updates automatically.",
					"vaccinesHint": "Filters by the period when the vaccine was administered. Updates automatically.",
					"examsHint": "Filters performed exams by result date (resulted_at / performed_at). Updates automatically."
				},
				"stats": {
					"petsTotal": "Total pets",
					"petsActive": "Active pets",
					"withMicrochip": "With microchip",
					"withoutMicrochip": "Without microchip",
					"weighedRecent": "Weighed in last 6 months",
					"weighedStale": "No weighing in 6+ months",
					"neverWeighed": "Never weighed",
					"applicationsTotal": "Applications",
					"petsVaccinated": "Pets vaccinated",
					"resultsTotal": "Performed exams",
					"petsWithResults": "Pets with exams",
					"panelResultsTotal": "Panel items",
					"typeResultsTotal": "Standalone exams"
				},
				"filters": {
					"title": "Filters",
					"tutor": "Tutor",
					"allTutors": "Entire system",
					"species": "Species",
					"allSpecies": "All species",
					"examKind": "Exam kind",
					"allExamKinds": "All kinds",
					"category": "Category",
					"allCategories": "All categories",
					"petSearch": "Search pet",
					"petSearchPlaceholder": "Pet name"
				},
				"charts": {
					"bySpecies": "By species",
					"byAge": "By age group",
					"byGender": "By sex",
					"byBreed": "By breed",
					"byBreedEmpty": "No pets with a registered breed for the current filter.",
					"byWeightStatus": "By weighing status",
					"byWeightStatusEmpty": "No weighing data for the current filter.",
					"byCreatedMonth": "Registrations by month",
					"byPetSpecies": "Vaccinated pets by species",
					"byMonth": "Applications by month",
					"byKind": "By vaccine kind",
					"byContext": "By application context",
					"byLocationType": "By location type",
					"applicationsSeries": "Applications",
					"registrationsSeries": "Registrations",
					"axis": {
						"species": "Species",
						"gender": "Sex",
						"breed": "Breed",
						"month": "Month",
						"kind": "Vaccine kind",
						"context": "Context",
						"locationType": "Location type",
						"count": "Count",
						"examKind": "Exam kind",
						"category": "Category"
					},
					"examsByPetSpecies": "Pets with exams by species",
					"resultsByMonth": "Performed exams by month",
					"resultsByMonthEmpty": "No performed exams in the selected period.",
					"byExamKind": "By exam kind",
					"byExamCategory": "By catalog category",
					"byExamCategoryEmpty": "No categories available for the current filter.",
					"resultsSeries": "Performed exams"
				},
				"age": {
					"puppy": "Puppy",
					"adult": "Adult",
					"senior": "Senior",
					"unknown": "Unknown",
					"hint": "Age group definitions:",
					"puppyHint": "Puppy: up to 11 months",
					"adultHint": "Adult: from 1 year to 6 years and 11 months",
					"seniorHint": "Senior: 7 years or more",
					"unknownHint": "Unknown: no birth date"
				},
				"labels": {
					"unknown": "Not informed"
				},
				"others": {
					"empty": "No items in the queue",
					"emptyTitle": "Queue is clear",
					"openFullQueue": "Open full queue",
					"promoteSuccess": "Item promoted successfully.",
					"dismissSuccess": "Item dismissed successfully.",
					"applications": "Applications",
					"typeKind": "Kind",
					"typeProduct": "Product",
					"dismiss": "Dismiss",
					"promote": "Promote",
					"cancel": "Cancel",
					"confirmPromote": "Confirm",
					"codeLabel": "Code",
					"defaultNameLabel": "Default name",
					"commercialNameLabel": "Commercial name",
					"kindLabel": "Vaccine kind",
					"kindPlaceholder": "Select kind",
					"speciesLabel": "Species"
				},
				"errors": {
					"load": "Could not load the dashboard.",
					"loadPets": "Could not load the pets dashboard.",
					"loadVaccines": "Could not load the vaccines dashboard.",
					"loadOthers": "Could not load the review queue.",
					"dismiss": "Could not dismiss the item.",
					"promote": "Could not promote the item.",
					"speciesRequired": "Select at least one species.",
					"kindRequired": "Select the vaccine kind.",
					"loadExams": "Could not load the exams dashboard."
				},
				"petsTable": {
					"title": "Pets with performed exams",
					"subtitle": "{{total}} pet(s) in the current filter",
					"emptyTitle": "No pets found",
					"empty": "There are no pets with performed exams for the selected filters.",
					"openExams": "Open exams",
					"prev": "Previous",
					"next": "Next",
					"page": "Page {{page}} of {{total}}",
					"columns": {
						"pet": "Pet",
						"species": "Species",
						"results": "Results",
						"lastResult": "Last result",
						"actions": "Actions"
					}
				}
			},
			"myData": {
				"saveSuccess": "Data saved successfully.",
				"saveFailed": "Could not save. Please try again.",
				"loadFailed": "Could not load your data.",
				"loading": "Loading your data…",
				"clearColor": "Restore default color",
				"tabsAria": "My data tabs",
				"tabs": {
					"profile": "Personal data",
					"alerts": "Notifications"
				},
				"form": {
					"fullNameLabel": "Full name",
					"fullNamePlaceholder": "Your full name",
					"preferredNameLabel": "Preferred name",
					"preferredNamePlaceholder": "How you prefer to be called",
					"emailLabel": "Email",
					"emailPlaceholder": "you@example.com",
					"phoneLabel": "Phone",
					"phonePlaceholder": "(11) 99999-9999",
					"themeColorLabel": "System color",
					"themeColorTooltip": "Color for customized use in the system. Change below to preview. You must click save to register the information."
				},
				"push": {
					"title": "Push notifications",
					"description": "Receive glucose curve alerts on this device (pet owner only). Best with installed PWA.",
					"enable": "Enable notifications",
					"disable": "Disable notifications",
					"enabled": "Notifications enabled.",
					"disabled": "Notifications disabled.",
					"failed": "Could not change notifications.",
					"unsupported": "This browser does not support Web Push."
				},
				"alerts": {
					"hiddenTitle": "Hide alerts",
					"hiddenDescription": "Choose which alert types should not appear in the list, overview, or alerts page.",
					"saveSuccess": "Alert preferences saved.",
					"saveFailed": "Could not save alert preferences.",
					"hideKind": {
						"preventive": "Hide alert: Preventives",
						"vaccine": "Hide alert: Vaccines",
						"glycemia": "Hide alert: Glycemia",
						"treatment": "Hide alert: Treatments",
						"visit": "Hide alert: Visits",
						"weight": "Hide alert: Weight",
						"birthday": "Hide alert: Birthdays"
					}
				}
			}
		}
	},
	"settings": {
		"preventives": {
			"tabs": {
				"brands": "Manufacturers",
				"products": "Products"
			},
			"active": "Active",
			"showDeleted": "Show deleted",
			"filters": {
				"search": "Search"
			},
			"actions": "Actions",
			"edit": "Edit",
			"delete": "Delete",
			"cancel": "Cancel",
			"brands": {
				"name": "Manufacturer",
				"createTitle": "Add manufacturer",
				"editTitle": "Edit manufacturer"
			},
			"products": {
				"name": "Commercial name",
				"brand": "Manufacturer",
				"category": "Category",
				"method": "Method",
				"species": "Species",
				"protectionValue": "Protection duration",
				"protectionUnit": "Period",
				"aliases": "Aliases (comma-separated)",
				"isOther": "Other product",
				"notes": "Notes",
				"createTitle": "Add product",
				"editTitle": "Edit product"
			},
			"empty": {
				"brands": {
					"title": "No manufacturers registered",
					"description": "Add the first manufacturer to the catalog."
				},
				"products": {
					"title": "No products registered",
					"description": "Add the first product to the catalog."
				}
			},
			"noResults": {
				"title": "No results found",
				"description": "Try adjusting the filters to find what you are looking for."
			},
			"errors": {
				"load": "Could not load the catalog.",
				"save": "Could not save the catalog.",
				"species": "Select at least one species.",
				"delete": "Could not delete the item."
			},
			"success": {
				"save": "Catalog saved successfully.",
				"delete": "Item deleted successfully."
			}
		}
	},
	"breeds": {
		"notInformed": "Not informed",
		"breedPlaceholder": "Select breed",
		"otherBreedLabel": "Breed description",
		"otherBreedPlaceholder": "Enter breed",
		"coatLabel": "Coat",
		"coatLengthLabel": "Coat length",
		"coatColorsLabel": "Coat colors",
		"coatColorsSearch": "Search color",
		"otherColorLabel": "Other color",
		"otherColorPlaceholder": "Describe the color",
		"lengths": {
			"hairless": "Hairless",
			"short": "Short",
			"medium": "Medium",
			"long": "Long"
		},
		"colors": {
			"white": "White",
			"black": "Black",
			"gray": "Gray",
			"silver": "Silver",
			"blue": "Blue",
			"brown": "Brown",
			"chocolate": "Chocolate",
			"liver": "Liver",
			"tan": "Tan",
			"cream": "Cream",
			"beige": "Beige",
			"fawn": "Fawn",
			"yellow": "Yellow",
			"golden": "Golden",
			"orange": "Orange",
			"red": "Red",
			"cinnamon": "Cinnamon",
			"lilac": "Lilac",
			"caramel": "Caramel",
			"sable": "Sable",
			"smoke": "Smoke",
			"other": "Other"
		}
	},
	"infos": {
		"photo": "Photo",
		"selectPhoto": "Select photo",
		"removePhoto": "Remove photo",
		"name": "Name",
		"age": "Age",
		"birth": "Birth date",
		"adoptionTime": "Adoption time",
		"adoptionDate": "Adoption date",
		"specie": "Species",
		"race": "Breed",
		"sex": "Sex",
		"coat": "Coat",
		"microchip": "Microchip",
		"microchipAbsent": "No microchip",
		"themeColor": "Pet color in the system",
		"themeColorTooltip": "Color for customized use in the system. Change below to preview. You must click save to register the information.",
		"photoUpload": {
			"selected": "Photo \"{{fileName}}\" selected. Click save to register.",
			"dropzone": "Drag and drop the photo here",
			"dropActive": "Drop the photo to upload",
			"browse": "or click to browse",
			"constraints": "Accepted formats: JPG, PNG, WebP up to 5MB",
			"disabled": "Photo upload disabled",
			"uploading": "Uploading photo...",
			"existingMeta": "Pet image",
			"cropAction": "Edit image (crop)",
			"cancelUploadAria": "Cancel upload",
			"removeFileAria": "Remove file",
			"invalidFileType": "File type not allowed",
			"fileTooLarge": "File exceeds maximum size (__MAX_SIZE__)",
			"uploadFailed": "Could not upload the file",
			"unknownExtension": "FILE",
			"cropper": {
				"title": "Crop image",
				"cancel": "Cancel",
				"apply": "Apply crop",
				"zoom": "Zoom",
				"ratio": "Aspect ratio",
				"rotateLeftAria": "Rotate left",
				"rotateRightAria": "Rotate right",
				"aspectFree": "Free",
				"aspectSquare": "Square (1:1)",
				"aspectFourThree": "4:3",
				"aspectSixteenNine": "16:9"
			}
		},
		"previewExpand": "Enlarge image",
		"healthCare": {
			"success": "Health and care information updated successfully.",
			"errors": {
				"genericTitle": "Could not save",
				"genericMessage": "Could not save health and care information. Please try again."
			},
			"neuteredStatus": {
				"label": "Neutered / spayed",
				"options": {
					"yes": "Yes",
					"no": "No",
					"unknown": "Unknown"
				}
			},
			"castrationDate": {
				"label": "Neutering / spay date"
			},
			"origin": {
				"label": "Animal origin",
				"options": {
					"breeder": "Breeder",
					"shelter": "Shelter / NGO",
					"rescue": "Rescue",
					"born_at_home": "Born at home",
					"other": "Other"
				}
			},
			"originOther": {
				"label": "Origin — Other",
				"placeholder": "Describe the animal's origin"
			},
			"livingEnvironment": {
				"label": "Living environment",
				"options": {
					"indoor_only": "Indoor — inside the home only",
					"outdoor_yard_only": "Outdoor — outside only (yard)",
					"outdoor_yard_street_access": "Outdoor — outside (yard + free street access)",
					"mixed_no_street_access": "Mixed — inside and outside without free street access",
					"mixed_with_street_access": "Mixed — inside and outside with free street access"
				}
			},
			"allergies": {
				"label": "Allergies",
				"placeholder": "Describe the animal's known allergies (medications, food, environmental, etc.)"
			},
			"feeding": {
				"label": "Feeding",
				"placeholder": "Food or usual diet name",
				"labelTooltip": "Enter the food brand name or describe the animal's daily diet, such as natural food and what they eat"
			}
		},
		"new": {
			"title": "Create pet",
			"subtitle": "Fill in the details below to register your pet in the system"
		},
		"time": {
			"and": "and",
			"year": "{count, plural, one {# year} other {# years}}",
			"month": "{count, plural, one {# month} other {# months}}",
			"day": "{count, plural, one {# day} other {# days}}"
		}
	},
	"loading": {
		"trying": "Loading...",
		"noResults": "No information found",
		"endOfList": "End of results"
	},
	"menu": {
		"expand": "Expand menu",
		"collapse": "Collapse menu",
		"language": {
			"label": "Language",
			"ariaLabel": "Current language",
			"options": {
				"pt": "Portuguese",
				"en": "English",
				"es": "Spanish",
				"fr": "French"
			}
		},
		"principal": {
			"title": "Pets",
			"profiles": {
				"master": {
					"title": "Pet management",
					"subtitle": "Manage your pets and view pets from other tutors when needed"
				},
				"vet": {
					"title": "Pets shared with me",
					"subtitle": "Track pets authorized by tutors and access their history"
				},
				"user": {
					"title": "My pets",
					"subtitle": "Track your pets, alerts, and important information in one place"
				}
			},
			"type": "pet",
			"petsList": "Pet list",
			"alerts": "Alerts",
			"registerPet": "Register pet"
		},
		"pet": {
			"title": "Pet",
			"overview": {
				"title": "Overview",
				"subtitle": "Summary of your pet’s health and care information"
			},
			"alerts": {
				"title": "Alerts",
				"subtitle": "Alerts and pending items for this pet"
			},
			"edit": {
				"title": "Edit pet",
				"subtitle": "Update your pet’s basic information",
				"tabs": {
					"general": "General Information",
					"healthCare": "Health & Care",
					"feeding": "Feeding",
					"access": "Access",
					"aria": "Pet edit sections"
				},
				"success": "Pet updated successfully.",
				"errors": {
					"conflictTitle": "Could not save",
					"conflictMessage": "A record with this data already exists.",
					"invalidTitle": "Invalid data",
					"invalidMessage": "Review the fields and try again.",
					"forbiddenTitle": "Permission denied",
					"forbiddenMessage": "Your session may have expired. Please sign in again.",
					"photoTooLargeTitle": "Photo too large",
					"photoTooLargeMessage": "The image exceeds the 5 MB limit. Choose a smaller file.",
					"photoTypeTitle": "Unsupported format",
					"photoTypeMessage": "Use a JPG, PNG, or WebP image.",
					"genericTitle": "Error saving pet",
					"genericMessage": "Please try again in a moment."
				}
			},
			"new": {
				"success": "Pet created successfully.",
				"errors": {
					"conflictTitle": "Could not create pet",
					"conflictMessage": "A record with this data already exists.",
					"invalidTitle": "Invalid data",
					"invalidMessage": "Review the fields and try again.",
					"forbiddenTitle": "Permission denied",
					"forbiddenMessage": "Your session may have expired. Please sign in again.",
					"photoTooLargeTitle": "Photo too large",
					"photoTooLargeMessage": "The image exceeds the 5 MB limit. Choose a smaller file.",
					"photoTypeTitle": "Unsupported format",
					"photoTypeMessage": "Use a JPG, PNG, or WebP image.",
					"genericTitle": "Error creating pet",
					"genericMessage": "Please try again in a moment."
				}
			},
			"weight": {
				"title": "Weights",
				"subtitle": "Weight history and progress tracking"
			},
			"preventives": {
				"title": "Preventives",
				"subtitle": "Flea and deworming control",
				"type": "Preventive",
				"new": "New record",
				"newSubtitle": "Record a preventive treatment for your pet",
				"edit": "Edit record",
				"editSubtitle": "Update the preventive record"
			},
			"veterinaryConsultation": {
				"title": "Consultations",
				"subtitle": "Veterinary consultation history",
				"type": "Consultation",
				"new": "New veterinary visit",
				"newSubtitle": "Record the visit and key clinical findings",
				"edit": "Edit veterinary visit",
				"editSubtitle": "Update the consultation details"
			},
			"vaccines": {
				"title": "Vaccines",
				"subtitle": "Record of vaccines administered to your pet",
				"type": "Vaccine",
				"new": "New vaccine administration",
				"newSubtitle": "Enter the context, location and application details",
				"edit": "Edit vaccine administration",
				"editSubtitle": "Update the vaccine application details"
			},
			"examsResults": {
				"title": "Exam results",
				"subtitle": "Results and history of exams requested during consultations",
				"type": "Exams",
				"new": "New exam result",
				"newSubtitle": "Record historical exams with date, values and attachments",
				"edit": "Edit exam result",
				"editSubtitle": "Update order details and exam values"
			},
			"examsResultsDetails": {
				"title": "Exam result details",
				"subtitle": "Information about the performed exam"
			},
			"examsComparisons": {
				"title": "Exam comparisons",
				"subtitle": "Progress and reference range",
				"type": "Exams"
			},
			"treatments": {
				"title": "Treatments",
				"subtitle": "Ongoing or temporary treatments",
				"type": "Treatment",
				"new": "New treatment",
				"newSubtitle": "Register an ongoing or temporary treatment",
				"edit": "Edit treatment",
				"editSubtitle": "Update the treatment details",
				"view": "View treatment",
				"viewSubtitle": "Finished plan — only notes can be added"
			},
			"clinicalConditions": {
				"title": "Clinical conditions",
				"subtitle": "Tracked diseases and health conditions",
				"type": "Condition",
				"details": "Condition: {name}",
				"detailsSubtitle": "Follow the history and notes for this condition",
				"new": "New clinical condition",
				"newSubtitle": "Register a clinical condition for your pet",
				"edit": "Edit clinical condition",
				"editSubtitle": "Update the clinical condition details"
			},
			"glucoseCurveMeasures": {
				"title": "Glucose measurements",
				"subtitle": "Monitoring of glucose curve measurements",
				"type": "Measurement",
				"new": "New blood glucose curve measurement",
				"newSubtitle": "Start a new glucose curve session",
				"details": "Measurement for {date}",
				"detailsFallback": "Measurement",
				"detailsSubtitle": "Details and points of the glucose curve"
			},
			"glucoseCurveComparison": {
				"title": "Glucose comparison",
				"subtitle": "Blood glucose trends over time",
				"type": "Measurement"
			},
			"glycemia": {
				"title": "Glucose",
				"subtitle": "Daily control, curve and comparison"
			}
		},
		"vet": {
			"title": "My shared pets",
			"subtitle": "Choose a pet to view its information and history"
		},
		"admin": {
			"title": "Admin records",
			"dashboard": "Dashboard",
			"dashboardSubtitle": "Overview of pets, vaccine applications and review queue",
			"typesOfVaccines": "Vaccine",
			"typesOfVaccinesSubtitle": "Kinds, brands, products and free-text review queue",
			"preventivesCatalog": "Preventives",
			"preventivesCatalogSubtitle": "Preventive brands and products",
			"diseases": "Diseases",
			"diseasesSubtitle": "Register and manage diseases linked to vaccines and conditions",
			"breeds": "Breeds",
			"breedsSubtitle": "Breeds, coat colors, and review queue",
			"exams": "Exams",
			"examsSubtitle": "Catalog, panels, audit and exam imports",
			"typesOfExams": "Exam types",
			"typesOfExamsSubtitle": "Register exam types and system references",
			"examinationPackage": "Exam packages",
			"examinationPackageSubtitle": "Build packages with sets of exams",
			"adminUsers": "System users",
			"adminUsersSubtitle": "Manage tutors, veterinarians and access status",
			"audit": "Audit",
			"auditSubtitle": "Authentication and admin action logs",
			"myDataSubtitle": "Personal details and notification preferences"
		},
		"fixed": {
			"myData": "My account",
			"mySettings": "My settings",
			"logout": "Log out"
		},
		"goBackTo": {
			"principal": "Back to pets"
		}
	},
	"overview": {
		"microchipAbsent": "None",
		"titles": {
			"infos": "Pet information",
			"nextVaccines": "Upcoming vaccines",
			"lastWeighIns": "Latest weigh-ins",
			"glycemicCurve": "Glucose curve",
			"glycemicCurveComparison": "Comparison latest curves."
		},
		"fields": {
			"microchip": "Microchip"
		},
		"weights": {
			"from": "From",
			"to": "To",
			"startDate": "Start date",
			"endDate": "End date",
			"dateAxis": "Date",
			"weightAxis": "Weight (kg)",
			"lastWeighIn": "Latest weigh-in:",
			"onDate": "on",
			"noRecords": "No records",
			"gained": "gained",
			"lost": "lost",
			"maintained": "maintained",
			"inPeriod": "during the period.",
			"open": "Register / View weights",
			"errors": {
				"endBeforeStart": "The end date cannot be earlier than the start date.",
				"sameDates": "The dates cannot be the same. Select two different ones."
			}
		},
		"glycemia": {
			"measurementDate": "Measurement date:",
			"minimum": "Min:",
			"maximum": "Max:",
			"average": "Average:",
			"clicks": "clicks",
			"register": "Register glucose",
			"viewMeasurement": "View measurement"
		},
		"completeness": {
			"title": "Missing information",
			"lead": "Basic important fields still missing for this pet:",
			"badgeOk": "Complete",
			"badgeMissing": "{count} pending",
			"emptyTitle": "All basic important information is filled in",
			"emptyDescription": "General profile, health & care, vaccines and weight look good for this pet.",
			"vaccinesTotal": "Vaccines registered",
			"weightsTotal": "Weights registered",
			"fields": {
				"microchip": "Microchip",
				"birthDate": "Date of birth",
				"adoptionDate": "Adoption date",
				"breed": "Breed",
				"coatLength": "Coat length",
				"coatColors": "Coat color",
				"neuteredStatus": "Neutered (yes / no / unknown)",
				"castrationDate": "Neutering date",
				"origin": "Animal origin",
				"livingEnvironment": "Living environment",
				"feeding": "Feeding",
				"vaccines": "No vaccine registered",
				"weights": "No weight registered"
			}
		}
	},
	"toast": {
		"successTitle": "Success!",
		"errorTitle": "Error!",
		"warningTitle": "Attention",
		"infoTitle": "Information"
	},
	"uiKit": {
		"form": {
			"selectPlaceholder": "Select",
			"searchPlaceholder": "Search...",
			"searchAriaLabel": "Search option",
			"emptyOptions": "No options found",
			"clearSelectionAria": "Clear selection"
		},
		"table": {
			"paginationAria": "Table pagination",
			"paginationTopSuffix": "(top)",
			"paginationBottomSuffix": "(bottom)",
			"previous": "Previous",
			"next": "Next",
			"first": "First",
			"last": "Last",
			"page": "Page",
			"of": "of",
			"total": "record(s)",
			"pageSizeAria": "Items per page",
			"sortBy": "Sort by __COLUMN__",
			"sortAsc": "ascending",
			"sortDesc": "descending"
		},
		"modal": {
			"confirm": "Confirm",
			"cancel": "Cancel",
			"close": "Close",
			"closeAria": "Close modal"
		},
		"toast": {
			"closeAria": "Close notification"
		},
		"loading": {
			"ariaLabel": "Loading content"
		},
		"tabs": {
			"ariaLabel": "Tabs"
		},
		"breadcrumb": {
			"ariaLabel": "Breadcrumb"
		},
		"switch": {
			"active": "On",
			"inactive": "Off"
		},
		"button": {
			"loading": "Loading..."
		},
		"alert": {
			"closeAria": "Close alert"
		},
		"fileUpload": {
			"pdfBadge": "pdf"
		}
	},
	"vaccines": {
		"kinds": {
			"BORDETELLA": "Bordetella",
			"FELV": "FeLV",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniasis",
			"CANINE_PUPPY": "Puppy",
			"RABIES": "Rabies",
			"TOSSE": "Canine cough and flu",
			"CANINE_V10": "V10",
			"CANINE_V11": "V11",
			"FELINE_V3": "V3",
			"FELINE_V4": "V4",
			"FELINE_V5": "V5",
			"CANINE_V6": "V6",
			"CANINE_V8": "V8",
			"OTHER": "Other"
		},
		"diseases": {
			"RABIES": "Rabies",
			"CANINE_DISTEMPER": "Distemper",
			"CANINE_ADENOVIRUS": "Adenovirus / Hepatitis",
			"CANINE_PARVOVIRUS": "Parvovirus",
			"CANINE_PARAINFLUENZA": "Parainfluenza",
			"LEPTOSPIROSIS": "Leptospirosis",
			"BORDETELLA": "Bordetella / Kennel cough",
			"GIARDIA": "Giardia",
			"LEISHMANIASIS": "Leishmaniasis",
			"FELINE_HERPESVIRUS": "Feline herpesvirus",
			"FELINE_CALICIVIRUS": "Feline calicivirus",
			"FELINE_PANLEUKOPENIA": "Feline panleukopenia",
			"FELINE_CHLAMYDIA": "Feline chlamydia",
			"FELINE_LEUKEMIA": "Feline leukemia (FeLV)"
		},
		"dose": {
			"unique": "single",
			"nth": "dose {n}",
			"last": "last dose"
		},
		"product": {
			"notInformed": "Not informed"
		},
		"context": {
			"consultation": "Veterinary consultation",
			"home": "Home care",
			"campaign": "Public campaign",
			"shelter_ngo": "NGO / Shelter",
			"hospital": "Veterinary hospital",
			"breeder": "Breeder (kennel/cattery)",
			"university": "University",
			"other": "Other"
		},
		"visitType": {
			"routine": "Routine",
			"return": "Follow-up",
			"emergency": "Emergency"
		},
		"visitMode": {
			"in_person": "In person",
			"home": "Home visit",
			"tele": "Telehealth"
		},
		"locationType": {
			"clinic": "Clinic",
			"home": "Home",
			"public_event": "Event / campaign",
			"shelter": "Shelter / NGO",
			"hospital": "Hospital",
			"breeder": "Breeder",
			"university": "University",
			"pet_shop": "Pet shop",
			"other": "Other"
		},
		"form": {
			"kindLabel": "Vaccine type",
			"kindPlaceholder": "Select type…",
			"productLabel": "Product / commercial brand",
			"productPlaceholder": "Select product…",
			"otherKindLabel": "Type name",
			"otherKindPlaceholder": "Enter the vaccine type",
			"otherProductLabel": "Product name",
			"otherProductPlaceholder": "Enter the product",
			"doseLabel": "Dose",
			"contextLabel": "Application context",
			"contextPlaceholder": "Select context…",
			"locationNameLabel": "Location",
			"locationNamePlaceholder": "Search clinic or location",
			"clinicOther": "Other",
			"clinicNameLabel": "Location name",
			"clinicNamePlaceholder": "E.g. Clinic X, shelter…",
			"homeLocationFixed": "Home",
			"visitTypeLabel": "Visit type",
			"visitTypePlaceholder": "Select type…",
			"visitModeLabel": "Visit mode",
			"visitModePlaceholder": "Select mode…",
			"weightLabel": "Weight (kg)",
			"weightPlaceholder": "E.g. 4.5",
			"weightReplaceTitle": "Replace today's weight?",
			"weightReplaceDescription": "There is already a weight of {existing} kg on this day. Replace it with {next} kg?",
			"weightReplaceConfirm": "Replace",
			"weightReplaceSkip": "Keep current weight",
			"visitLabel": "Related visit",
			"visitPlaceholder": "Select visit…",
			"administeredAtLabel": "Administered on",
			"administeredAtTimeLabel": "Time",
			"nextDoseLabel": "Next dose",
			"administeredByLabel": "Professional",
			"vetCrmvLabel": "License (CRMV)",
			"vetCrmvPlaceholder": "E.g. CRMV-SP 12345",
			"clinicLabel": "Clinic",
			"notesLabel": "Notes / side effects",
			"notesPlaceholder": "Record reactions, effects or complications…",
			"visitInternalNotes": "Vaccine application",
			"kindOrProductHint": "You can pick the type, the product, or only the product — the type is filled in automatically.",
			"dosesSingular": "1 dose",
			"dosesPlural": "{count} doses",
			"successSave": "Vaccine saved successfully.",
			"errorSave": "Could not save the vaccine. Please try again.",
			"addVaccine": "Add vaccine",
			"removeVaccine": "Remove vaccine",
			"sectionTitle": "Vaccines administered",
			"vaccinesSectionHint": "For each vaccine given on this day, enter the type, product and next dose date.",
			"cancel": "Cancel"
		}
	},
	"preventives": {
		"form": {
			"loading": "Loading preventive…",
			"appliedAtLabel": "Application date",
			"kindLabel": "Which",
			"kindPlaceholder": "Select…",
			"methodLabel": "Type",
			"methodPlaceholder": "Select…",
			"productLabel": "Product",
			"productPlaceholder": "E.g. NexGard, Bravecto…",
			"productCatalogPlaceholder": "Search for a product…",
			"otherProduct": "Other / not listed",
			"otherProductLabel": "Product name",
			"protectionValueLabel": "Protection duration",
			"protectionValuePlaceholder": "E.g. 30",
			"protectionUnitLabel": "Period",
			"protectionUnitPlaceholder": "Select…",
			"unitDays": "Days",
			"unitMonths": "Months",
			"recurringLabel": "Recurring application",
			"recurringTooltip": "When enabled, creates a home alert based on the next dose.",
			"nextDueAtLabel": "Next dose",
			"calculateNextDue": "Calculate next date",
			"recalculate": "Recalculate",
			"autoSuggestion": "Automatic suggestion: {date}",
			"weightLabel": "Weight on the day (kg)",
			"weightPlaceholder": "E.g. 4.5",
			"weightReplaceTitle": "Replace today's weight?",
			"weightReplaceDescription": "There is already a weight of {existing} kg on this day. Replace it with {next} kg?",
			"weightReplaceConfirm": "Replace",
			"weightReplaceSkip": "Keep current weight",
			"notesLabel": "Notes",
			"notesPlaceholder": "Add notes",
			"cancel": "Cancel",
			"success": {
				"create": "Preventive saved successfully.",
				"update": "Preventive updated successfully."
			},
			"errors": {
				"load": "Could not load the preventive.",
				"save": "Could not save the preventive.",
				"recalculate": "Could not recalculate the next dose."
			},
			"sourceTreatmentLabel": "Source treatment",
			"sourceTreatmentPlaceholder": "Link to a treatment"
		},
		"categories": {
			"pulgas_carrapatos": "Fleas and ticks",
			"pulgas": "Fleas",
			"vermifugo": "Dewormer",
			"vermifugo_dirofilariose": "Dewormer and heartworm",
			"combo_interno_externo": "Internal and external protection",
			"outro": "Other"
		},
		"methods": {
			"comprimido": "Tablet",
			"injecao": "Injection",
			"coleira": "Collar",
			"pipeta": "Pipette",
			"spray": "Spray",
			"shampoo": "Shampoo",
			"liquido": "Liquid",
			"pasta": "Paste",
			"outro": "Other"
		}
	},
	"appUpdate": {
		"title": "New version available",
		"message": "A system update is ready. Refresh to load the latest texts and fixes.",
		"reload": "Update now",
		"later": "Later",
		"errorTitle": "Update",
		"unrecoverable": "The app needs to reload to continue."
	},
	"offline": {
		"banner": "No connection. Your form data stays on this device and can be sent when the connection returns."
	},
	"weight": {
		"loading": "Loading weight history",
		"readOnlyInfo": "Only the pet's tutor can add or delete weights.",
		"unit": {
			"kg": "kg"
		},
		"form": {
			"panelTitle": "Add a new weight"
		},
		"tabs": {
			"aria": "Weight views",
			"summary": "Summary",
			"stats": "Statistics",
			"timeline": "Timeline"
		},
		"summary": {
			"initial": "Initial weight",
			"current": "Current weight",
			"last": "Last weight",
			"trend": "Trend"
		},
		"trend": {
			"up": "Weight gain",
			"down": "Weight loss",
			"flat": "Stable weight"
		},
		"stats": {
			"loading": "Loading statistics",
			"periodNote": "* Statistical data based on the last 12 months.",
			"insufficient": {
				"title": "Not enough data",
				"description": "At least 2 weight records in the last 12 months are required to show statistics."
			},
			"max": "Highest weight",
			"min": "Lowest weight",
			"average": "Average weight",
			"averageBasis": "Based on {count} records",
			"amplitude": "Range",
			"amplitudeMeta": "Between lowest and highest weight",
			"lastWeighing": "Last weighing",
			"lastWeighingToday": "Today",
			"lastWeighingOneDay": "1 day ago",
			"lastWeighingDays": "{days} days ago",
			"ratePerWeek": "Average change",
			"ratePerWeekMeta": "From first to last record in the period",
			"ratePerWeekValue": "{value} kg/week",
			"frequency": "Frequency",
			"frequencyMeta": "Average interval between records",
			"frequencyDays": "Every {days} days",
			"frequencyOneDay": "Daily on average",
			"notAvailable": "—",
			"trend": "Trend",
			"error": {
				"title": "Could not load statistics",
				"description": "Something went wrong while calculating weight statistics. Please try again.",
				"retry": "Try again"
			}
		},
		"timeline": {
			"sortAria": "Toggle timeline order",
			"sortNewest": "Newest first",
			"sortOldest": "Oldest first",
			"loadingMore": "Loading more records"
		},
		"empty": {
			"title": "No weight recorded",
			"description": "Track your pet's development! Weight is extremely important!",
			"descriptionReadOnly": "There is no weight recorded for this pet."
		},
		"loadError": {
			"title": "Could not load weights",
			"description": "Something went wrong while fetching the weight history. Please try again.",
			"retry": "Try again"
		},
		"errors": {
			"save": "Could not save the weight. Please try again.",
			"duplicateDate": "A weight is already registered on this day",
			"delete": "Could not delete the record. Please try again.",
			"loadMore": "Could not load more records."
		},
		"success": {
			"save": "Weight saved successfully.",
			"delete": "Weight record deleted."
		},
		"delete": {
			"title": "Delete weight record?",
			"contentWithRecord": "This action cannot be undone. Record: {record}",
			"contentGeneric": "This action cannot be undone.",
			"confirm": "Delete",
			"cancel": "Cancel"
		},
		"actions": {
			"deleteAria": "Delete weight record"
		}
	},
	"feeding": {
		"loading": "Loading feeding",
		"historyTitle": "History",
		"changedFeeding": "I changed the diet",
		"stoppedFeeding": "I stopped it",
		"stop": {
			"title": "Stop feeding",
			"description": "Do you want to end \"{product}\"? It will move to history and won't be replaced.",
			"confirm": "Stop",
			"cancel": "Cancel"
		},
		"history": {
			"from": "From: {date}",
			"to": "Until: {date}"
		},
		"card": {
			"since": "Since {date}",
			"notesPrefix": "Note: "
		},
		"empty": {
			"activeTitle": "No feeding registered",
			"activeDescription": "Register the pet’s current food or diet to track changes over time.",
			"historyTitle": "No history",
			"historyDescription": "When a feeding item is replaced, it will appear here."
		},
		"form": {
			"titleAdd": "Add food",
			"titleChange": "I changed the diet",
			"type": "Type",
			"product": "Product",
			"productPlaceholder": "Select a product from the catalog",
			"productOther": "Other",
			"brandName": "Brand",
			"brandNamePlaceholder": "E.g. Royal Canin",
			"productName": "Product name",
			"productNamePlaceholder": "E.g. adult kibble, home-cooked diet",
			"flavor": "Flavor",
			"flavorPlaceholder": "E.g. chicken",
			"purpose": "Purpose",
			"format": "Format",
			"frequencyUnit": "Frequency",
			"frequencyTimes": "Times",
			"frequencyTimesPlaceholder": "E.g. 2",
			"frequencyOther": "Describe the frequency",
			"frequencyOtherPlaceholder": "E.g. every 2 days, weekends only",
			"startDate": "Start date",
			"endDate": "Previous end date",
			"notes": "Notes",
			"notesPlaceholder": "Add notes"
		},
		"type": {
			"dry_food": "Dry food",
			"wet_food": "Wet food",
			"natural_home_cooked": "Home-cooked natural",
			"natural_commercial": "Commercial natural",
			"raw_diet": "Raw diet (BARF)",
			"milk_formula": "Milk / formula",
			"enteral_diet": "Enteral diet",
			"other": "Other"
		},
		"purpose": {
			"maintenance": "Maintenance",
			"growth": "Growth",
			"weight_control": "Weight control",
			"therapeutic": "Therapeutic",
			"recovery": "Recovery",
			"senior": "Senior",
			"other": "Other"
		},
		"format": {
			"kibble": "Kibble",
			"sachet": "Sachet",
			"can": "Can",
			"pate": "Pâté",
			"mousse": "Mousse",
			"frozen": "Frozen",
			"refrigerated": "Refrigerated",
			"dehydrated": "Dehydrated",
			"freeze_dried": "Freeze-dried",
			"liquid": "Liquid",
			"other": "Other"
		},
		"frequency": {
			"unit": {
				"day": "Per day",
				"week": "Per week",
				"free": "Free",
				"other": "Other"
			},
			"label": {
				"day": "{times}x per day",
				"week": "{times}x per week",
				"free": "Free (always available)"
			}
		},
		"success": {
			"create": "Food added successfully.",
			"change": "Feeding updated successfully.",
			"stop": "Feeding ended successfully."
		},
		"errors": {
			"loadTitle": "Could not load",
			"loadMessage": "Something went wrong while loading feeding. Please try again.",
			"saveTitle": "Could not save",
			"saveMessage": "Review the fields and try again.",
			"stopMessage": "Could not end the feeding. Please try again."
		}
	},
	"table": {
		"totalCount": "<span class='hide-mobile'>Total of </span><strong>{ total }</strong> registers"
	},
	"noResults": {
		"vaccines": "No further vaccines"
	}
}
